webpackJsonp([4],{

/***/ 3685:
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },

/***/ 3767:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(3627);
	
	var _helpers = __webpack_require__(3670);
	
	var _Builder = __webpack_require__(3768);
	
	var _Builder2 = _interopRequireDefault(_Builder);
	
	var _selectors = __webpack_require__(3610);
	
	var _ruleDetails = __webpack_require__(3612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    ruleBranches: (0, _selectors.getRuleBranches)(state),
	    entityHierarchy: state.ruleDetails.entityHierarchy,
	    currentAdvertiser: (0, _selectors.getCurrentAdvertiserObject)(state),
	    meta: (0, _selectors.getMeta)(state),
	    ruleSettings: state.ruleDetails.ruleSettings,
	    entityScopes: state.ruleDetails.entityScopes,
	    editing: state.ruleDetails.editing,
	    savable: (0, _selectors.isRuleSavable)(state),
	    users: state.ruleDetails.users,
	    isPackage: (0, _selectors.getIsPackage)(state),
	    ruleset: state.ruleDetails.ruleset,
	    scopeEntityType: (0, _selectors.getScopeEntityType)(state.ruleDetails),
	    selectedEntityIds: (0, _selectors.getSelectedEntityIds)(state.ruleDetails),
	    ruleSaving: state.ruleDetails.saving,
	    ruleSettingsValid: state.ruleDetails.ruleSettingsValid,
	    isRuleSettingsValid: (0, _selectors.isRuleSettingsValid)(state.ruleDetails.ruleSettings),
	    invalidEntities: state.ruleDetails.invalidEntities
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    ruleSettingsActions: (0, _helpers.buildActionsCollection)({
	      updateRuleSettings: _ruleDetails.updateRuleSettings,
	      updateEntityScope: _ruleDetails.updateEntityScope,
	      fetchAdvertiserEntities: _ruleDetails.fetchAdvertiserEntities
	    }, dispatch),
	    ruleDetailsActions: (0, _helpers.buildActionsCollection)({
	      addRuleBranch: _ruleDetails.addRuleBranch,
	      removeRuleBranch: _ruleDetails.removeRuleBranch,
	      updateRuleBranch: _ruleDetails.updateRuleBranch,
	      addConditionGroup: _ruleDetails.addConditionGroup,
	      removeConditionGroup: _ruleDetails.removeConditionGroup,
	      updateConditionGroup: _ruleDetails.updateConditionGroup,
	      addCondition: _ruleDetails.addCondition,
	      updateCondition: _ruleDetails.updateCondition,
	      removeCondition: _ruleDetails.removeCondition,
	      addTask: _ruleDetails.addTask,
	      updateTask: _ruleDetails.updateTask,
	      removeTask: _ruleDetails.removeTask,
	      editEntity: _ruleDetails.editEntity,
	      fetchTriggersAndOperators: _ruleDetails.fetchTriggersAndOperators,
	      fetchLocations: _ruleDetails.fetchLocations
	    }, dispatch),
	    builderActions: (0, _helpers.buildActionsCollection)({
	      saveRule: _ruleDetails.saveRule,
	      updateEntitiesValidation: _ruleDetails.updateEntitiesValidation
	    }, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Builder2.default);

/***/ },

/***/ 3768:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _reactRouter = __webpack_require__(717);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _constants = __webpack_require__(3609);
	
	var _RuleSettings = __webpack_require__(3769);
	
	var _RuleSettings2 = _interopRequireDefault(_RuleSettings);
	
	var _RuleLogic = __webpack_require__(3780);
	
	var _RuleLogic2 = _interopRequireDefault(_RuleLogic);
	
	__webpack_require__(3824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Builder = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(Builder, _Component);
	
	  function Builder() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Builder);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Builder.__proto__ || (0, _getPrototypeOf2.default)(Builder)).call.apply(_ref, [this].concat(args))), _this), _this.renderSaveButton = function () {
	      var _this$props = _this.props,
	          savable = _this$props.savable,
	          ruleSaving = _this$props.ruleSaving;
	
	
	      var saveLabel = ruleSaving ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'builder.save.button.saving.on.label',
	        defaultMessage: 'Saving...'
	      }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'builder.save.button.saving.off.label',
	        defaultMessage: 'Save Rule'
	      });
	
	      var button = _react2.default.createElement(
	        _antd.Button,
	        {
	          className: 'save-or-create-button',
	          type: 'primary',
	          disabled: !_this.props.savable,
	          loading: _this.props.ruleSaving,
	          onClick: function onClick() {
	            _this.props.builderActions('saveRule');
	          }
	        },
	        saveLabel
	      );
	
	      if (!savable) {
	        return _react2.default.createElement(
	          _antd.Tooltip,
	          {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'builder.saveButton.tooltip',
	              defaultMessage: 'Required fields missing and/or some conditions/tasks have not been saved'
	            })
	          },
	          button
	        );
	      }
	
	      return button;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Builder, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isPackage = _props.isPackage,
	          ruleset = _props.ruleset;
	
	      var rulesetName = ruleset.name || '';
	      var ruleSetUrl = isPackage ? '/automation_engine' : '/automation_engine/rule_sets';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'builder__component' },
	        _react2.default.createElement(
	          'div',
	          { className: 'build-a-rule-text' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'builder.title.text',
	            defaultMessage: 'Rule Builder'
	          })
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          { className: 'm-t-5' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 20, className: 'ruleset-label' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'builder.ruleset.label',
	                defaultMessage: 'Rule Set'
	              }),
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'ruleset-name' },
	              rulesetName
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, className: 'text-align-right' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: ruleSetUrl },
	              _react2.default.createElement(_antd.Icon, { type: 'left' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'builder.backToRuleSets.link',
	                defaultMessage: 'Back to Rule Sets'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_RuleSettings2.default, {
	          ruleset: ruleset,
	          ruleSettings: this.props.ruleSettings,
	          entityHierarchy: this.props.entityHierarchy,
	          ruleSettingsActions: this.props.ruleSettingsActions,
	          currentAdvertiser: this.props.currentAdvertiser,
	          scopeEntityType: this.props.scopeEntityType,
	          selectedEntityIds: this.props.selectedEntityIds,
	          isRuleSettingsValid: this.props.isRuleSettingsValid
	        }),
	        _react2.default.createElement(_RuleLogic2.default, {
	          ruleDetailsActions: this.props.ruleDetailsActions,
	          ruleBranches: this.props.ruleBranches,
	          editing: this.props.editing,
	          meta: this.props.meta,
	          ruleSettings: this.props.ruleSettings,
	          users: this.props.users,
	          builderActions: this.props.builderActions,
	          invalidEntities: this.props.invalidEntities
	        }),
	        this.renderSaveButton()
	      );
	    }
	  }]);
	  return Builder;
	}(_react.Component), _class.propTypes = {
	  ruleDetailsActions: _propTypes2.default.func.isRequired,
	  ruleSettingsActions: _propTypes2.default.func.isRequired,
	  builderActions: _propTypes2.default.func.isRequired,
	  currentAdvertiser: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.number.isRequired
	  }).isRequired,
	  ruleBranches: _RuleLogic2.default.propTypes.ruleBranches,
	  editing: _RuleLogic2.default.propTypes.editing,
	  meta: _propTypes2.default.shape(_RuleLogic2.default.propTypes.meta).isRequired,
	  entityHierarchy: _propTypes2.default.shape({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      value: _propTypes2.default.string.isRequired,
	      label: _propTypes2.default.string.isRequired,
	      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired,
	        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	          value: _propTypes2.default.string.isRequired,
	          label: _propTypes2.default.string.isRequired
	        }))
	      }))
	    })).isRequired,
	    loading: _propTypes2.default.bool.isRequired
	  }).isRequired,
	  ruleSettings: _propTypes2.default.shape(_RuleLogic2.default.propTypes.ruleSettings).isRequired,
	  savable: _propTypes2.default.bool,
	  ruleSaving: _propTypes2.default.bool.isRequired,
	  users: _propTypes2.default.shape(_RuleLogic2.default.propTypes.users).isRequired,
	  isPackage: _propTypes2.default.bool.isRequired,
	  ruleset: _propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    id: _propTypes2.default.number,
	    startTime: _propTypes2.default.string,
	    endTime: _propTypes2.default.string
	  }).isRequired,
	  scopeEntityType: _propTypes2.default.oneOf(_constants.ENTITY_SCOPE.map(function (entityScope) {
	    return entityScope.value;
	  })),
	  selectedEntityIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	  isRuleSettingsValid: _propTypes2.default.bool.isRequired,
	  invalidEntities: _propTypes2.default.shape({
	    ruleBranches: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	    conditionGroups: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	    conditions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	    tasks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))
	  }).isRequired
	}, _class.defaultProps = {
	  editing: {
	    conditions: {},
	    tasks: {}
	  },
	  ruleBranches: [],
	  scopeEntityType: null,
	  selectedEntityIds: [],
	  savable: false
	}, _temp2);
	exports.default = Builder;

/***/ },

/***/ 3769:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _momentTimezone = __webpack_require__(2665);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _EntityScope = __webpack_require__(3770);
	
	var _EntityScope2 = _interopRequireDefault(_EntityScope);
	
	__webpack_require__(3772);
	
	var _constants = __webpack_require__(3609);
	
	var _helpers = __webpack_require__(3608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var TabPane = _antd.Tabs.TabPane;
	var Option = _antd.Select.Option;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var forIn = __webpack_require__(3773);
	
	var RuleSettings = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(RuleSettings, _Component);
	
	  function RuleSettings(props) {
	    (0, _classCallCheck3.default)(this, RuleSettings);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RuleSettings.__proto__ || (0, _getPrototypeOf2.default)(RuleSettings)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      modalVisible: false,
	      submitEntityScopeForm: false,
	      entityScopeFormIsValid: null
	    };
	    _this.initializeForm();
	    return _this;
	  }
	
	  (0, _createClass3.default)(RuleSettings, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.initializeForm();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          scopeEntityType = _props.scopeEntityType,
	          selectedEntityIds = _props.selectedEntityIds,
	          currentAdvertiser = _props.currentAdvertiser,
	          ruleset = _props.ruleset;
	      var _props$ruleSettings = this.props.ruleSettings,
	          aggregationLevel = _props$ruleSettings.aggregationLevel,
	          dataRangeRelative = _props$ruleSettings.dataRangeRelative,
	          scheduleType = _props$ruleSettings.scheduleType;
	
	      var entityScopeMessage = (0, _helpers.generateEntitySelectedMsg)(aggregationLevel, scopeEntityType, selectedEntityIds, currentAdvertiser.name);
	
	      var errorBadge = !this.isFormValid() || this.state.entityScopeFormIsValid === false ? _react2.default.createElement(_antd.Badge, { className: 'pane-error-badge', count: '!' }) : null;
	
	      var disabledDate = function disabledDate(current) {
	        return current && (_momentTimezone2.default.tz(current, ruleset.timezone).startOf('day').valueOf() > _momentTimezone2.default.tz(ruleset.endTime, ruleset.timezone).startOf('day').valueOf() || _momentTimezone2.default.tz(current, ruleset.timezone).startOf('day').valueOf() < (0, _momentTimezone2.default)().tz(ruleset.timezone).startOf('day').valueOf() || _momentTimezone2.default.tz(current, ruleset.timezone).startOf('day').valueOf() < _momentTimezone2.default.tz(ruleset.startTime, ruleset.timezone).startOf('day').valueOf());
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ruleSettings__component' },
	        _react2.default.createElement(
	          _antd.Tabs,
	          null,
	          _react2.default.createElement(
	            TabPane,
	            { tab: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.label', defaultMessage: 'Rule Settings' }),
	                ' ',
	                errorBadge
	              ), key: '1' },
	            _react2.default.createElement(
	              _antd.Form,
	              { layout: 'vertical', hideRequiredMark: true },
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 4, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.ruleName.label', defaultMessage: 'Rule Name' }),
	                      className: 'warning-field'
	                    },
	                    getFieldDecorator('name', {
	                      rules: [{ required: true, message: 'Missing Rule Name', whitespace: true }]
	                    })(_react2.default.createElement(_antd.Input, { placeholder: "Enter a rule name" }))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 4, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.frequency.label', defaultMessage: 'Check conditions every:' })
	                    },
	                    getFieldDecorator('frequency')(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        showSearch: false,
	                        style: { width: '100%' }
	                      },
	                      _constants.FREQUENCIES.map(function (frequency) {
	                        return _react2.default.createElement(
	                          Option,
	                          { key: frequency.value, value: frequency.value },
	                          frequency.label
	                        );
	                      })
	                    ))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 3, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.schedule.label', defaultMessage: 'Schedule' })
	                    },
	                    getFieldDecorator('scheduleType')(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        showSearch: false,
	                        style: { width: '100%' }
	                      },
	                      _constants.RULE_SCHEDULE.map(function (option) {
	                        return _react2.default.createElement(
	                          Option,
	                          { key: option.value, value: option.value },
	                          option.label
	                        );
	                      })
	                    ))
	                  )
	                ),
	                scheduleType === 'SET_SCHEDULE' && _react2.default.createElement(
	                  _antd.Col,
	                  { span: 4, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.selectDates.label', defaultMessage: 'Select Dates' }),
	                        ' ',
	                        this.scheduleFieldTooltip
	                      )
	                    },
	                    getFieldDecorator('schedule', {
	                      rules: [{ required: scheduleType === 'SET_SCHEDULE', message: 'Missing date range' }]
	                    })(_react2.default.createElement(RangePicker, {
	                      style: { width: '100%' },
	                      showTime: {
	                        defaultValue: [(0, _momentTimezone2.default)('00:00:00', 'HH:mm:ss'), (0, _momentTimezone2.default)('23:59:59', 'HH:mm:ss')]
	                      },
	                      format: 'MMM-DD-YY',
	                      allowClear: true,
	                      disabledDate: disabledDate,
	                      disabledTime: function disabledTime(selectedDates, type) {
	                        return (0, _helpers.disableTimeRange)(selectedDates, type, ruleset.startTime, ruleset.endTime, ruleset.timezone);
	                      }
	                    }))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 3, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.status.label', defaultMessage: 'Status' })
	                    },
	                    getFieldDecorator('status')(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        showSearch: false,
	                        style: { width: '100%' }
	                      },
	                      _constants.STATUS.map(function (status) {
	                        return _react2.default.createElement(
	                          Option,
	                          { key: status.value, value: status.value },
	                          status.label
	                        );
	                      })
	                    ))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 4, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.selectEntities.label', defaultMessage: 'Scope' })
	                    },
	                    _react2.default.createElement(
	                      _antd.Button,
	                      {
	                        className: 'select-entities-btn',
	                        onClick: function onClick() {
	                          return _this2.toggleModal();
	                        }
	                      },
	                      _react2.default.createElement(_antd.Icon, { type: 'plus' }),
	                      _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'ruleSettings.openSelectEntities.button',
	                        defaultMessage: 'Select Campaigns'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _antd.Modal,
	                      {
	                        title: 'Choose what this Rule applies to',
	                        visible: this.state.modalVisible,
	                        onCancel: this.toggleModal,
	                        width: 900,
	                        maskClosable: false,
	                        footer: [_react2.default.createElement(
	                          _antd.Button,
	                          { key: 'cancel', onClick: function onClick() {
	                              return _this2.toggleModal();
	                            } },
	                          _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'ruleSettings.entityScopeModal.cancel.button.label',
	                            defaultMessage: 'Cancel'
	                          })
	                        ), _react2.default.createElement(
	                          _antd.Button,
	                          { key: 'submit', type: 'primary', onClick: function onClick() {
	                              return _this2.submitEntityScopeForm();
	                            } },
	                          _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'ruleSettings.entityScopeModal.confirm.button.label',
	                            defaultMessage: 'Ok'
	                          })
	                        )]
	                      },
	                      _react2.default.createElement(_EntityScope2.default, {
	                        entityHierarchy: this.props.entityHierarchy,
	                        currentAdvertiser: this.props.currentAdvertiser,
	                        aggregationLevel: this.props.ruleSettings.aggregationLevel,
	                        scopeEntityType: this.props.scopeEntityType,
	                        selectedEntityIds: this.props.selectedEntityIds,
	                        onEntityScopeFormSubmit: this.onEntityScopeFormSubmit,
	                        submitEntityScopeForm: this.state.submitEntityScopeForm,
	                        ruleSettingsActions: this.props.ruleSettingsActions
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 24 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'entity-scope-message' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                      id: 'ruleSettings.entityScopeMessage',
	                      defaultMessage: 'Currently affecting: {entityScopeMessage}',
	                      values: { entityScopeMessage: entityScopeMessage }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('hr', null),
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 4, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.dateRange.label', defaultMessage: 'Use data from: ' }),
	                        _react2.default.createElement(
	                          _antd.Tooltip,
	                          {
	                            placement: 'top',
	                            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                              id: 'ruleSettings.dataRange.field.tooltip',
	                              defaultMessage: 'Data sync occurs every 20 minutes. Expect delays for changes made directly on native publisher tools. Updates made in AdParlor will be available immediately.'
	                            })
	                          },
	                          _react2.default.createElement(_antd.Icon, { type: 'info-circle-o' })
	                        )
	                      )
	                    },
	                    getFieldDecorator('dataRangeRelative')(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        showSearch: false,
	                        style: { width: '100%' }
	                      },
	                      _constants.DATA_RANGE.map(function (range) {
	                        return _react2.default.createElement(
	                          Option,
	                          { key: range.value, value: range.value },
	                          range.label
	                        );
	                      })
	                    ))
	                  )
	                ),
	                dataRangeRelative === 'LAST_N_DAYS' && _react2.default.createElement(
	                  _antd.Col,
	                  { span: 2, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.nDays.label', defaultMessage: 'Days (n)' })
	                    },
	                    getFieldDecorator('lastNDays', {
	                      rules: [{ required: dataRangeRelative === 'LAST_N_DAYS', message: 'Enter number of days', whitespace: true }],
	                      validateTrigger: 'onKeyUp'
	                    })(_react2.default.createElement(_antd.InputNumber, {
	                      min: 0,
	                      style: { width: '100%' }
	                    }))
	                  )
	                ),
	                dataRangeRelative === 'DATE_RANGE' && _react2.default.createElement(
	                  _antd.Col,
	                  { span: 5, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.specificDateRange.label', defaultMessage: 'Select Dates' })
	                    },
	                    getFieldDecorator('specificDateRange', {
	                      rules: [{ required: dataRangeRelative === 'DATE_RANGE', message: 'Missing date range' }]
	                    })(_react2.default.createElement(RangePicker, {
	                      style: { width: '100%' },
	                      format: 'MMM-DD-YY',
	                      allowClear: true
	                    }))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 3, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.attributionClickWindow.label', defaultMessage: 'Click Attribution' })
	                    },
	                    getFieldDecorator('attributionClickWindow')(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        showSearch: false,
	                        style: { width: '100%' }
	                      },
	                      _constants.ATTRIBUTION_CLICK_WINDOW.map(function (clickWindow) {
	                        return _react2.default.createElement(
	                          Option,
	                          { key: clickWindow.value, value: clickWindow.value },
	                          clickWindow.label
	                        );
	                      })
	                    ))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 3, className: 'rule-setting-form-field-col' },
	                  _react2.default.createElement(
	                    FormItem,
	                    {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.attributionViewWindow.label', defaultMessage: 'View Attribution' })
	                    },
	                    getFieldDecorator('attributionViewWindow')(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        showSearch: false,
	                        style: { width: '100%' }
	                      },
	                      _constants.ATTRIBUTION_VIEW_WINDOW.map(function (viewWindow) {
	                        return _react2.default.createElement(
	                          Option,
	                          { key: viewWindow.value, value: viewWindow.value },
	                          viewWindow.label
	                        );
	                      })
	                    ))
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return RuleSettings;
	}(_react.Component), _class.propTypes = {
	  form: _propTypes2.default.shape({
	    getFieldsError: _propTypes2.default.func.isRequired,
	    validateFields: _propTypes2.default.func.isRequired,
	    getFieldDecorator: _propTypes2.default.func.isRequired,
	    getFieldError: _propTypes2.default.func.isRequired,
	    getFieldValue: _propTypes2.default.func.isRequired,
	    setFieldsInitialValue: _propTypes2.default.func.isRequired
	  }).isRequired,
	  scopeEntityType: _propTypes2.default.oneOf(_constants.ENTITY_SCOPE.map(function (entityScope) {
	    return entityScope.value;
	  })),
	  selectedEntityIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	  ruleSettings: _propTypes2.default.shape({
	    aggregationLevel: _propTypes2.default.oneOf(_constants.AGGREGATION_LEVELS.map(function (aggregationLevel) {
	      return aggregationLevel.value;
	    })),
	    dataRangeRelative: _propTypes2.default.string,
	    scheduleType: _propTypes2.default.string
	  }).isRequired,
	  ruleSettingsActions: _propTypes2.default.func.isRequired,
	  entityHierarchy: _propTypes2.default.shape({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      value: _propTypes2.default.string.isRequired,
	      label: _propTypes2.default.string.isRequired,
	      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired,
	        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	          value: _propTypes2.default.string.isRequired,
	          label: _propTypes2.default.string.isRequired
	        }))
	      }))
	    })).isRequired,
	    loading: _propTypes2.default.bool.isRequired
	  }).isRequired,
	  ruleset: _propTypes2.default.shape({
	    startTime: _propTypes2.default.string,
	    endTime: _propTypes2.default.string
	  }),
	  currentAdvertiser: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.number.isRequired
	  }).isRequired
	}, _class.defaultProps = {
	  scopeEntityType: null,
	  aggregationLevel: null,
	  selectedEntityIds: null,
	  ruleset: {
	    startTime: (0, _momentTimezone2.default)(),
	    endTime: (0, _momentTimezone2.default)(),
	    timezone: 'America/Toronto'
	  }
	}, _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.toggleModal = function () {
	    var _props2 = _this3.props,
	        ruleSettingsActions = _props2.ruleSettingsActions,
	        currentAdvertiser = _props2.currentAdvertiser,
	        entityHierarchy = _props2.entityHierarchy;
	
	    if (!entityHierarchy.data.length) {
	      ruleSettingsActions('fetchAdvertiserEntities', currentAdvertiser.id);
	    }
	    _this3.setState(function (prevState, props) {
	      return { modalVisible: !prevState.modalVisible };
	    });
	  };
	
	  this.onEntityScopeFormSubmit = function (values, isValid) {
	    _this3.setState({ entityScopeFormIsValid: isValid, modalVisible: !isValid, submitEntityScopeForm: false }, function () {
	      if (values && isValid) {
	        var selectedEntityIds = values.selectedEntityIds,
	            scopeEntityType = values.scopeEntityType,
	            aggregationLevel = values.aggregationLevel;
	
	
	        if (selectedEntityIds || scopeEntityType) {
	          _this3.props.ruleSettingsActions('updateEntityScope', {
	            scopeEntityType: scopeEntityType,
	            selectedEntityIds: selectedEntityIds
	          });
	        }
	
	        if (aggregationLevel) {
	          _this3.props.ruleSettingsActions('updateRuleSettings', {
	            aggregationLevel: {
	              value: aggregationLevel
	            }
	          });
	        }
	      }
	    });
	  };
	
	  this.submitEntityScopeForm = function () {
	    _this3.setState({ submitEntityScopeForm: true });
	  };
	
	  this.scheduleFieldTooltip = _react2.default.createElement(
	    _antd.Tooltip,
	    {
	      key: 'schedule-field-tooltip',
	      placement: 'top',
	      title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'ruleSettings.schedule.field.tooltip',
	        defaultMessage: 'Rules use the Rule Set schedule unless otherwise specified.'
	      })
	    },
	    _react2.default.createElement(_antd.Icon, { type: 'info-circle-o' })
	  );
	
	  this.initializeForm = function () {
	    var props = _this3.props;
	
	    var specificDateRange = props.ruleSettings.dataRangeAbsoluteStart && props.ruleSettings.dataRangeAbsoluteEnd ? [(0, _momentTimezone2.default)(props.ruleSettings.dataRangeAbsoluteStart), (0, _momentTimezone2.default)(props.ruleSettings.dataRangeAbsoluteEnd)] : [];
	    var defaultStartTime = props.ruleSettings.startTime ? _momentTimezone2.default.tz(props.ruleSettings.startTime, props.ruleset.timezone) : null;
	    var defaultEndTime = props.ruleSettings.endTime ? _momentTimezone2.default.tz(props.ruleSettings.endTime, props.ruleset.timezone) : null;
	
	    props.form.setFieldsInitialValue({
	      name: props.ruleSettings.name,
	      frequency: props.ruleSettings.frequency,
	      schedule: [defaultStartTime, defaultEndTime],
	      status: props.ruleSettings.status,
	      dataRangeRelative: props.ruleSettings.dataRangeRelative,
	      specificDateRange: specificDateRange,
	      lastNDays: props.ruleSettings.lastNDays,
	      attributionClickWindow: props.ruleSettings.attributionClickWindow !== null ? props.ruleSettings.attributionClickWindow.toString() : null,
	      attributionViewWindow: props.ruleSettings.attributionViewWindow !== null ? props.ruleSettings.attributionViewWindow.toString() : null,
	      scheduleType: props.ruleSettings.scheduleType
	    });
	  };
	
	  this.isFormValid = function () {
	    var isValid = 1;
	    var _props$ruleSettings2 = _this3.props.ruleSettings,
	        dataRangeRelative = _props$ruleSettings2.dataRangeRelative,
	        scheduleType = _props$ruleSettings2.scheduleType;
	
	    var errors = _this3.props.form.getFieldsError();
	
	    if (dataRangeRelative !== 'DATE_RANGE') errors.specificDateRange = null;
	    if (dataRangeRelative !== 'LAST_N_DAYS') errors.lastNDays = null;
	    if (scheduleType === 'ONGOING') errors.schedule = null;
	
	    forIn(errors, function (value, key) {
	      if (value && value.length > 0) {
	        isValid *= 0;
	      }
	    });
	    return isValid === 1;
	  };
	}, _temp);
	
	
	var RuleSettingsForm = _antd.Form.create({
	  onFieldsChange: function onFieldsChange(props, changedFields) {
	    props.ruleSettingsActions('updateRuleSettings', changedFields);
	  }
	})(RuleSettings);
	
	exports.default = RuleSettingsForm;

/***/ },

/***/ 3770:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	__webpack_require__(3771);
	
	var _constants = __webpack_require__(3609);
	
	var _helpers = __webpack_require__(3608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var SHOW_CHILD = _antd.TreeSelect.SHOW_CHILD;
	
	var EntityScope = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(EntityScope, _Component);
	
	  function EntityScope(props) {
	    (0, _classCallCheck3.default)(this, EntityScope);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EntityScope.__proto__ || (0, _getPrototypeOf2.default)(EntityScope)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.initializeForm();
	    return _this;
	  }
	
	  (0, _createClass3.default)(EntityScope, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.scopeEntityType !== this.props.scopeEntityType || prevProps.selectedEntityIds !== this.props.selectedEntityIds || prevProps.aggregationLevel !== this.props.aggregationLevel) {
	        this.initializeForm();
	      }
	
	      if (this.props.submitEntityScopeForm !== prevProps.submitEntityScopeForm && this.props.submitEntityScopeForm === true) {
	        this.checkValidation();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$form = this.props.form,
	          getFieldDecorator = _props$form.getFieldDecorator,
	          getFieldValue = _props$form.getFieldValue;
	      var _props = this.props,
	          currentAdvertiser = _props.currentAdvertiser,
	          entityHierarchy = _props.entityHierarchy;
	
	
	      var entityHierarchyLoading = entityHierarchy.loading ? { hasFeedback: true, validateStatus: "validating", disabled: true } : {};
	
	      var aggregationLevelValue = getFieldValue('aggregationLevel');
	      var scopeEntityTypeValue = getFieldValue('scopeEntityType');
	      var selectedEntityIdsValue = getFieldValue('selectedEntityIds');
	
	      var hideSelectedEntityIdsValue = scopeEntityTypeValue && scopeEntityTypeValue === "FB_ADVERTISER";
	      var selectedEntityMessage = (0, _helpers.generateEntitySelectedMsg)(aggregationLevelValue, scopeEntityTypeValue, selectedEntityIdsValue, currentAdvertiser.name);
	      var aggregationLevelOptions = _constants.AGGREGATION_LEVELS.map(function (entity) {
	        return _react2.default.createElement(
	          Option,
	          { key: entity.value, value: entity.value },
	          entity.label
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'entityScope__component' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', hideRequiredMark: true },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              {
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.aggregationLevelLabel', defaultMessage: 'Apply rule to' }),
	                colon: false
	              },
	              getFieldDecorator('aggregationLevel', {
	                rules: [{ required: true, message: 'Missing aggregation level' }],
	                validateTrigger: 'onChange'
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: false,
	                  style: { width: 150 },
	                  placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.aggregationLevelPlaceholder', defaultMessage: 'Select an entity level' }),
	                  onChange: this.onAggregationLevelChange
	                },
	                aggregationLevelOptions
	              ))
	            ),
	            _react2.default.createElement(
	              FormItem,
	              {
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.entityScopeLabel', defaultMessage: 'within' }),
	                colon: false
	              },
	              getFieldDecorator('scopeEntityType', {
	                rules: [{ required: true, message: 'Missing entity scope' }],
	                validateTrigger: 'onChange'
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: false,
	                  style: { width: 150 },
	                  notFoundContent: 'Entity level required',
	                  placeholder: 'Select an entity scope',
	                  onChange: this.onScopeEntityTypeChange
	                },
	                aggregationLevelValue && this.renderEntityScopeOptions(aggregationLevelValue, scopeEntityTypeValue)
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { className: '' + (hideSelectedEntityIdsValue ? 'hide' : '') },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                (0, _extends3.default)({
	                  label: 'Select entities',
	                  colon: false
	                }, entityHierarchyLoading),
	                getFieldDecorator('selectedEntityIds', {
	                  rules: [{
	                    required: true,
	                    message: 'Missing entities'
	                  }],
	                  validateTrigger: 'onSelect'
	                })(_react2.default.createElement(_antd.TreeSelect, {
	                  treeData: this.getTreeData(scopeEntityTypeValue),
	                  showCheckedStrategy: SHOW_CHILD,
	                  disabled: entityHierarchyLoading.disabled,
	                  multiple: true,
	                  treeCheckable: true,
	                  filterTreeNode: function filterTreeNode(input, option) {
	                    return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  treeNodeFilterProp: 'label',
	                  placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.selectEntityPlaceholder', defaultMessage: 'Search Campaigns/Ad Sets' }),
	                  style: { width: 867 },
	                  dropdownStyle: { maxHeight: 400 },
	                  allowClear: true,
	                  onChange: this.onSelectedEntityIdsChange,
	                  getPopupContainer: function getPopupContainer() {
	                    return document.getElementsByClassName('entityScope__component')[0];
	                  }
	                }))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'entity-scope-message' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'entityScope.modal.selectedEntityMessage',
	              defaultMessage: 'This Rule applies to: {selectedEntityMessage}',
	              values: { selectedEntityMessage: selectedEntityMessage }
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return EntityScope;
	}(_react.Component), _class.propTypes = {
	  entityHierarchy: _propTypes2.default.shape({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      value: _propTypes2.default.string.isRequired,
	      label: _propTypes2.default.string.isRequired,
	      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired,
	        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	          value: _propTypes2.default.string.isRequired,
	          label: _propTypes2.default.string.isRequired
	        }))
	      }))
	    })).isRequired,
	    loading: _propTypes2.default.bool.isRequired
	  }).isRequired,
	  submitEntityScopeForm: _propTypes2.default.bool.isRequired,
	  onEntityScopeFormSubmit: _propTypes2.default.func.isRequired,
	  currentAdvertiser: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.number.isRequired
	  }).isRequired,
	  form: _propTypes2.default.shape({
	    getFieldValue: _propTypes2.default.func.isRequired,
	    getFieldDecorator: _propTypes2.default.func.isRequired,
	    getFieldError: _propTypes2.default.func.isRequired,
	    setFieldsValue: _propTypes2.default.func.isRequired,
	    setFieldsInitialValue: _propTypes2.default.func.isRequired,
	    isFieldsTouched: _propTypes2.default.func.isRequired,
	    validateFields: _propTypes2.default.func.isRequired
	  }).isRequired,
	  scopeEntityType: _propTypes2.default.oneOf(_constants.ENTITY_SCOPE.map(function (entityScope) {
	    return entityScope.value;
	  })),
	  selectedEntityIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	  aggregationLevel: _propTypes2.default.oneOf(_constants.AGGREGATION_LEVELS.map(function (aggregationLevel) {
	    return aggregationLevel.value;
	  }))
	}, _class.defaultProps = {
	  scopeEntityType: null,
	  selectedEntityIds: null,
	  aggregationLevel: null
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getTreeData = function (scopeEntityType) {
	    var entityHierarchy = _this2.props.entityHierarchy;
	
	    var filteredHierarchy = void 0;
	    if (scopeEntityType === 'FB_CAMPAIGN') {
	      filteredHierarchy = entityHierarchy.data.map(function (campaign) {
	        return (0, _extends3.default)({}, campaign, { children: [] });
	      });
	      return filteredHierarchy;
	    } else if (scopeEntityType === 'FB_ADSET') {
	      filteredHierarchy = entityHierarchy.data.filter(function (campaign) {
	        return campaign.children.length;
	      }).map(function (campaign) {
	        var adsets = campaign.children.map(function (adset) {
	          return (0, _extends3.default)({}, adset, { children: [] });
	        });
	        return (0, _extends3.default)({}, campaign, { children: adsets });
	      });
	      return filteredHierarchy;
	    }
	    filteredHierarchy = entityHierarchy.data.map(function (campaign) {
	      var adsets = campaign.children.filter(function (adset) {
	        return adset.children.length;
	      });
	      return (0, _extends3.default)({}, campaign, { children: adsets });
	    }).filter(function (campaign) {
	      return campaign.children.length;
	    });
	    return filteredHierarchy;
	  };
	
	  this.renderEntityScopeOptions = function (aggregationLevel, entityScope) {
	    return _constants.ENTITY_SCOPE.map(function (entityScope) {
	      if ((0, _helpers.isEntityScopeValid)(aggregationLevel, entityScope.value)) {
	        return _react2.default.createElement(
	          Option,
	          { key: entityScope.value, value: entityScope.value },
	          entityScope.label
	        );
	      }
	      return [];
	    });
	  };
	
	  this.onAggregationLevelChange = function (aggregationLevel) {
	    var _props$form2 = _this2.props.form,
	        getFieldValue = _props$form2.getFieldValue,
	        setFieldsValue = _props$form2.setFieldsValue;
	
	    if (!(0, _helpers.isEntityScopeValid)(aggregationLevel, getFieldValue('scopeEntityType'))) {
	      setFieldsValue({
	        scopeEntityType: null,
	        selectedEntityIds: []
	      });
	    }
	
	    _this2.setState({
	      aggregationLevel: aggregationLevel,
	      scopeEntityType: getFieldValue('scopeEntityType'),
	      selectedEntityIds: getFieldValue('selectedEntityIds')
	    });
	  };
	
	  this.onScopeEntityTypeChange = function (value) {
	    var currentAdvertiser = _this2.props.currentAdvertiser;
	    var setFieldsValue = _this2.props.form.setFieldsValue;
	
	
	    var newSelectedEntityIdsValue = [];
	
	    if (value === 'FB_ADVERTISER') {
	      newSelectedEntityIdsValue.push(currentAdvertiser.id.toString());
	    }
	
	    setFieldsValue({
	      selectedEntityIds: newSelectedEntityIdsValue
	    });
	
	    /**
	     * We set the evaluated value of the state.selectedEntityIds rather than the
	     * actual form field value to ensure no race conditions happen and throw
	     * both things out of sync.
	     */
	    _this2.setState({ scopeEntityType: value, selectedEntityIds: newSelectedEntityIdsValue });
	  };
	
	  this.onSelectedEntityIdsChange = function (value) {
	    var getFieldValue = _this2.props.form.getFieldValue;
	
	    _this2.setState({ selectedEntityIds: value, scopeEntityType: getFieldValue('scopeEntityType') });
	  };
	
	  this.initializeForm = function () {
	    var props = _this2.props;
	    var _props$form3 = props.form,
	        setFieldsInitialValue = _props$form3.setFieldsInitialValue,
	        getFieldDecorator = _props$form3.getFieldDecorator;
	
	    getFieldDecorator('aggregationLevel');
	    getFieldDecorator('scopeEntityType');
	    getFieldDecorator('selectedEntityIds');
	    setFieldsInitialValue({
	      aggregationLevel: props.aggregationLevel,
	      scopeEntityType: props.scopeEntityType,
	      selectedEntityIds: props.selectedEntityIds
	    });
	  };
	
	  this.checkValidation = function () {
	    _this2.props.form.validateFields(function (error, value) {
	      if (error) {
	        _this2.props.onEntityScopeFormSubmit(_this2.state, false);
	      } else {
	        _this2.props.onEntityScopeFormSubmit(_this2.state, true);
	      }
	    }, {
	      force: true
	    });
	  };
	}, _temp);
	exports.default = _antd.Form.create({})(EntityScope);

/***/ },

/***/ 3771:
/***/ function(module, exports) {



/***/ },

/***/ 3772:
/***/ function(module, exports) {



/***/ },

/***/ 3773:
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(3774),
	    createForIn = __webpack_require__(3777);
	
	/**
	 * Iterates over own and inherited enumerable properties of an object invoking
	 * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	 * with three arguments: (value, key, object). Iteratee functions may exit
	 * iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forIn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	 */
	var forIn = createForIn(baseFor);
	
	module.exports = forIn;


/***/ },

/***/ 3774:
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(3775);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },

/***/ 3775:
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(3776);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },

/***/ 3776:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3602);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },

/***/ 3777:
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(3778),
	    keysIn = __webpack_require__(3607);
	
	/**
	 * Creates a function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {Function} objectFunc The function to iterate over an object.
	 * @returns {Function} Returns the new each function.
	 */
	function createForIn(objectFunc) {
	  return function(object, iteratee, thisArg) {
	    if (typeof iteratee != 'function' || thisArg !== undefined) {
	      iteratee = bindCallback(iteratee, thisArg, 3);
	    }
	    return objectFunc(object, iteratee, keysIn);
	  };
	}
	
	module.exports = createForIn;


/***/ },

/***/ 3778:
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(3779);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },

/***/ 3779:
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },

/***/ 3780:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _helpers = __webpack_require__(3608);
	
	var _RuleBranch = __webpack_require__(3781);
	
	var _RuleBranch2 = _interopRequireDefault(_RuleBranch);
	
	__webpack_require__(3823);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RuleLogic = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(RuleLogic, _React$Component);
	
	  function RuleLogic() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RuleLogic);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RuleLogic.__proto__ || (0, _getPrototypeOf2.default)(RuleLogic)).call.apply(_ref, [this].concat(args))), _this), _this.showAddRuleBranchText = {
	      IF: "If these conditions are met",
	      ELSEIF: "Alternatively If",
	      ELSE: "Otherwise"
	    }, _this.availableActions = {
	      actions: {
	        ruleBranch: {
	          remove: function remove(id) {
	            _this.props.ruleDetailsActions('removeRuleBranch', id);
	          },
	          update: function update(id, updates) {
	            _this.props.ruleDetailsActions('updateRuleBranch', id, updates);
	          }
	        },
	        conditionGroup: {
	          add: function add(ruleBranchID) {
	            _this.props.ruleDetailsActions('addConditionGroup', ruleBranchID);
	          },
	          remove: function remove(ruleBranchID, id) {
	            _this.props.ruleDetailsActions('removeConditionGroup', ruleBranchID, id);
	          },
	          update: function update(id, ruleBranchID, updates) {
	            _this.props.ruleDetailsActions('updateConditionGroup', id, ruleBranchID, updates);
	          }
	        },
	        condition: {
	          add: function add(conditionGroupID, ruleBranchId) {
	            _this.props.ruleDetailsActions('addCondition', conditionGroupID, ruleBranchId);
	          },
	          update: function update(id, conditionGroupID, ruleBranchId, updates) {
	            _this.props.ruleDetailsActions('updateCondition', id, conditionGroupID, ruleBranchId, updates);
	          },
	          edit: function edit(id) {
	            _this.props.ruleDetailsActions('editEntity', id, 'conditions', true);
	          },
	          cancelEdit: function cancelEdit(id) {
	            _this.props.ruleDetailsActions('editEntity', id, 'conditions', false);
	          },
	          remove: function remove(id, conditionGroupID, ruleBranchId) {
	            _this.props.ruleDetailsActions('removeCondition', id, conditionGroupID, ruleBranchId);
	          },
	          fetchLocations: function fetchLocations(query, successCallback, errorCallback) {
	            _this.props.ruleDetailsActions('fetchLocations', query, successCallback, errorCallback);
	          }
	        },
	        task: {
	          add: function add(ruleBranchId) {
	            _this.props.ruleDetailsActions('addTask', ruleBranchId);
	          },
	          remove: function remove(ruleBranchId, id) {
	            _this.props.ruleDetailsActions('removeTask', ruleBranchId, id);
	          },
	          edit: function edit(id) {
	            _this.props.ruleDetailsActions('editEntity', id, 'tasks', true);
	          },
	          cancelEdit: function cancelEdit(id) {
	            _this.props.ruleDetailsActions('editEntity', id, 'tasks', false);
	          },
	          update: function update(id, ruleBranchID, updates) {
	            _this.props.ruleDetailsActions('updateTask', id, ruleBranchID, updates);
	          }
	        }
	      }
	    }, _this.renderAddRuleBranchButton = function (clauseIntro) {
	      return _react2.default.createElement(
	        _antd.Button,
	        {
	          type: 'dashed',
	          className: 'new-rule-branch-button',
	          onClick: function onClick() {
	            _this.props.ruleDetailsActions('addRuleBranch', clauseIntro);
	          },
	          key: 'add-rule-branch-' + clauseIntro.toLowerCase()
	        },
	        '+ ',
	        _this.showAddRuleBranchText[clauseIntro]
	      );
	    }, _this.renderBranches = function () {
	      var ruleBranches = _this.props.ruleBranches;
	
	      var ruleBranchesRender = [];
	
	      // Render all rule branches
	      ruleBranches.forEach(function (ruleBranch, ruleBranchIndex) {
	        ruleBranchesRender.push(_react2.default.createElement(_RuleBranch2.default, {
	          key: 'rule-branch-' + ruleBranch.id,
	          ruleBranch: ruleBranch,
	          options: _this.availableActions,
	          editingConditions: _this.props.editing.conditions,
	          meta: _this.props.meta,
	          editingTasks: _this.props.editing.tasks,
	          ruleSettings: _this.props.ruleSettings,
	          users: _this.props.users,
	          builderActions: _this.props.builderActions,
	          invalidEntities: _this.props.invalidEntities
	        }));
	        // If this is the last rule branch for the specific clauseIntro, display button to add another rule branch
	        if (ruleBranch.showAddRuleBranch) {
	          ruleBranchesRender.push(_this.renderAddRuleBranchButton(ruleBranch.clauseIntro));
	        }
	      });
	
	      // If we do not have any ELSEIF rule branches, display button to add
	      if ((0, _helpers.getRuleBranchesByType)(ruleBranches, "ELSEIF").length === 0) {
	        if ((0, _helpers.getRuleBranchesByType)(ruleBranches, "ELSE").length !== 0) {
	          // Insert as second last element
	          ruleBranchesRender.splice(ruleBranchesRender.length - 1, 0, _this.renderAddRuleBranchButton("ELSEIF"));
	        } else {
	          ruleBranchesRender.push(_this.renderAddRuleBranchButton("ELSEIF"));
	        }
	      }
	      // If we do not have any ELSE rule branches, display button to add
	      if ((0, _helpers.getRuleBranchesByType)(ruleBranches, "ELSE").length === 0) {
	        ruleBranchesRender.push(_this.renderAddRuleBranchButton("ELSE"));
	      }
	
	      return ruleBranchesRender;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RuleLogic, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ruleLogic__component' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            this.renderBranches()
	          )
	        )
	      );
	    }
	  }]);
	  return RuleLogic;
	}(_react2.default.Component), _class.propTypes = {
	  ruleDetailsActions: _propTypes2.default.func.isRequired,
	  ruleBranches: _propTypes2.default.arrayOf(_RuleBranch2.default.propTypes.ruleBranch).isRequired,
	  editing: _propTypes2.default.shape({
	    conditions: _RuleBranch2.default.propTypes.editingConditions,
	    tasks: _RuleBranch2.default.propTypes.editingTasks
	  }).isRequired,
	  meta: _propTypes2.default.shape(_RuleBranch2.default.propTypes.meta).isRequired,
	  ruleSettings: _propTypes2.default.shape(_RuleBranch2.default.propTypes.ruleSettings).isRequired,
	  users: _propTypes2.default.shape(_RuleBranch2.default.propTypes.users).isRequired,
	  invalidEntities: _propTypes2.default.shape(_RuleBranch2.default.propTypes.invalidEntities).isRequired,
	  builderActions: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = RuleLogic;

/***/ },

/***/ 3781:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	__webpack_require__(3782);
	
	var _ConditionGroup = __webpack_require__(3783);
	
	var _ConditionGroup2 = _interopRequireDefault(_ConditionGroup);
	
	var _Task = __webpack_require__(3821);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Panel = _antd.Collapse.Panel;
	
	var RuleBranch = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(RuleBranch, _React$Component);
	
	  function RuleBranch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RuleBranch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RuleBranch.__proto__ || (0, _getPrototypeOf2.default)(RuleBranch)).call.apply(_ref, [this].concat(args))), _this), _this.removeRuleBranchOrConditionGroup = function (isFirstConditionGroup, ruleBranchId, conditionGroupId) {
	      var _this$props = _this.props,
	          options = _this$props.options,
	          ruleBranch = _this$props.ruleBranch;
	      var conditionGroups = ruleBranch.conditionGroups,
	          clauseIntro = ruleBranch.clauseIntro;
	      // If it is the first conidtionGroup, remove the ruleBranch
	
	      var removeRuleBranch = isFirstConditionGroup && conditionGroups && conditionGroups.length === 1 || clauseIntro === 'ELSE';
	      if (removeRuleBranch) {
	        options.actions.ruleBranch.remove(ruleBranch);
	      } else {
	        // Else, remove the conidtionGroup instead
	        var conditionGroupToRemove = conditionGroups.find(function (group) {
	          return group.id === conditionGroupId;
	        });
	        options.actions.conditionGroup.remove(ruleBranchId, conditionGroupToRemove);
	      }
	    }, _this.shouldShowRemoveButton = function (id, isFirstConditionGroup) {
	      var ruleBranch = _this.props.ruleBranch;
	
	      if (ruleBranch.clauseIntro === 'IF') {
	        return !isFirstConditionGroup;
	      } else if (ruleBranch.clauseIntro === 'ELSE') {
	        return true;
	      }
	      if (id) {
	        return true;
	      }
	      return false;
	    }, _this.renderGroupHeader = function (_ref2, isFirstConditionGroup, invalidGroup) {
	      var id = _ref2.id,
	          title = _ref2.title,
	          headerLabel = _ref2.headerLabel;
	      var ruleBranch = _this.props.ruleBranch;
	
	      var invalidBadge = invalidGroup === true ? _react2.default.createElement(_antd.Badge, { count: '!' }) : null;
	      var showRemoveButton = _this.shouldShowRemoveButton(id, isFirstConditionGroup);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 20, key: 'rule-branch-title-' + ruleBranch.id, className: 'condition-title' },
	            headerLabel ? _react2.default.createElement(
	              'div',
	              { className: 'header-label' },
	              headerLabel
	            ) : null,
	            title,
	            ' ',
	            invalidBadge
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            {
	              span: 4,
	              className: 'text-align-right',
	              key: 'rule-branch-actions-' + ruleBranch.id
	            },
	            showRemoveButton && _react2.default.createElement(_antd.Button, {
	              shape: 'circle',
	              icon: 'close',
	              className: 'rule-branch-actions-remove',
	              key: 'rule-branch-actions-remove-' + ruleBranch.id,
	              onClick: function onClick() {
	                return _this.removeRuleBranchOrConditionGroup(isFirstConditionGroup, ruleBranch.id, id);
	              }
	            })
	          )
	        )
	      );
	    }, _this.quantifierSelector = function (ruleBranchID, currentQuantifier, selectedQuantifier) {
	      if (currentQuantifier !== selectedQuantifier) {
	        _this.props.options.actions.ruleBranch.update(ruleBranchID, { quantifier: selectedQuantifier });
	      }
	      _this.props.options.actions.conditionGroup.add(ruleBranchID);
	    }, _this.showAddConditionGroup = function () {
	      var ruleBranch = _this.props.ruleBranch;
	
	      return _react2.default.createElement(
	        _antd.Dropdown,
	        {
	          overlay: _this.newConditionGroupMenu(ruleBranch.id, ruleBranch.quantifier, ruleBranch.conditionGroups.length > 1),
	          getPopupContainer: function getPopupContainer(node) {
	            return node.parentNode;
	          },
	          className: 'dropdown-condition',
	          trigger: ['click']
	        },
	        _react2.default.createElement(
	          _antd.Button,
	          { type: 'dashed', className: 'condition-group-add-button' },
	          '+ ',
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'rulebranch.collapse.conditiongroup.add.button',
	            defaultMessage: 'Additional Condition Group'
	          })
	        )
	      );
	    }, _this.renderConditionGroups = function () {
	      var _this$props2 = _this.props,
	          ruleBranch = _this$props2.ruleBranch,
	          options = _this$props2.options,
	          editingConditions = _this$props2.editingConditions,
	          meta = _this$props2.meta,
	          invalidEntities = _this$props2.invalidEntities,
	          ruleSettings = _this$props2.ruleSettings;
	
	      if (ruleBranch.conditionGroups) {
	        // ELSE clauseIntro does not have conditionGroups
	        return ruleBranch.conditionGroups.map(function (conditionGroup, conditionGroupIndex) {
	          var isFirstConditionGroup = conditionGroupIndex === 0;
	          return _react2.default.createElement(
	            Panel,
	            {
	              header: _this.renderGroupHeader(conditionGroup, isFirstConditionGroup, invalidEntities.conditionGroups.includes(conditionGroup.id)),
	              className: conditionGroup.className,
	              key: 'conditionGroup-' + conditionGroup.id
	            },
	            _react2.default.createElement(_ConditionGroup2.default, {
	              conditionGroup: conditionGroup,
	              ruleBranchID: ruleBranch.id,
	              conditionGroupActions: options.actions.conditionGroup,
	              conditionActions: options.actions.condition,
	              metaActions: options.actions.meta,
	              key: conditionGroup.id,
	              editingConditions: editingConditions,
	              meta: meta,
	              builderActions: _this.props.builderActions,
	              ruleSettings: ruleSettings
	            }),
	            conditionGroup.showAddConditionGroup && _this.showAddConditionGroup()
	          );
	        });
	      }
	      return null;
	    }, _this.renderTasks = function () {
	      var _this$props3 = _this.props,
	          ruleBranch = _this$props3.ruleBranch,
	          options = _this$props3.options,
	          ruleSettings = _this$props3.ruleSettings,
	          users = _this$props3.users,
	          editingTasks = _this$props3.editingTasks;
	      var taskGroup = ruleBranch.taskGroup;
	
	      var taskDelimeter = _react2.default.createElement(
	        'div',
	        { className: 'task-delimeter' },
	        taskGroup.quantifier === "ALL" ? "AND" : "OR"
	      );
	      return taskGroup.tasks.map(function (task, taskIndex) {
	        return _react2.default.createElement(
	          'div',
	          { key: task.id },
	          _react2.default.createElement(_Task2.default, {
	            task: task,
	            key: task.id,
	            ruleBranchID: ruleBranch.id,
	            ruleSettings: ruleSettings,
	            removable: taskGroup.tasks.length > 1 || ruleBranch.clauseIntro === "ELSE",
	            taskActions: options.actions.task,
	            editing: editingTasks.includes(task.id),
	            users: users,
	            builderActions: _this.props.builderActions
	          }),
	          taskGroup.tasks[taskIndex + 1] && taskDelimeter
	        );
	      });
	    }, _this.renderTaskGroup = function () {
	      var _this$props4 = _this.props,
	          ruleBranch = _this$props4.ruleBranch,
	          options = _this$props4.options,
	          invalidEntities = _this$props4.invalidEntities;
	      var taskGroup = ruleBranch.taskGroup;
	
	      var invalidTasks = taskGroup.tasks.filter(function (task) {
	        return invalidEntities.tasks.includes(task.id);
	      });
	
	      return _react2.default.createElement(
	        Panel,
	        {
	          header: _this.renderGroupHeader(taskGroup, true, invalidTasks.length > 0),
	          className: taskGroup.className,
	          key: 'taskGroup-' + ruleBranch.id
	        },
	        _this.renderTasks(),
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            onClick: function onClick() {
	              options.actions.task.add(ruleBranch.id);
	            },
	            type: 'dashed',
	            className: 'add-task-button',
	            size: 'small'
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'rulebranch.add.task.button',
	            defaultMessage: '+ Add Task'
	          })
	        )
	      );
	    }, _this.getActiveKeys = function () {
	      var ruleBranch = _this.props.ruleBranch;
	
	      var keys = ['taskGroup-' + ruleBranch.id];
	      if (ruleBranch.conditionGroups) {
	        ruleBranch.conditionGroups.forEach(function (conditionGroup) {
	          return keys.push('conditionGroup-' + conditionGroup.id);
	        });
	      }
	      return keys;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RuleBranch, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.editingConditions !== nextProps.editingConditions || this.props.editingTasks !== nextProps.editingTasks || this.props.ruleBranch !== nextProps.ruleBranch || this.props.meta !== nextProps.meta || this.props.ruleSettings !== nextProps.ruleSettings || this.props.users !== nextProps.users || this.props.invalidEntities.conditionGroups !== nextProps.invalidEntities.conditionGroups || this.props.invalidEntities.tasks !== nextProps.invalidEntities.tasks;
	    }
	  }, {
	    key: 'newConditionGroupMenu',
	    value: function newConditionGroupMenu(ruleBranchID, currentQuantifier, limitReached) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _antd.Menu,
	        null,
	        _react2.default.createElement(
	          _antd.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              disabled: currentQuantifier === 'ANY' && limitReached === true,
	              onClick: function onClick() {
	                return _this2.quantifierSelector(ruleBranchID, currentQuantifier, 'ALL');
	              }
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'rulebranch.quantifier.all',
	              defaultMessage: 'And'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              disabled: currentQuantifier === 'ALL' && limitReached === true,
	              onClick: function onClick() {
	                return _this2.quantifierSelector(ruleBranchID, currentQuantifier, 'ANY');
	              }
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'rulebranch.quantifier.any',
	              defaultMessage: 'Or'
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var keys = this.getActiveKeys();
	      return _react2.default.createElement(
	        'div',
	        { className: 'ruleBranch__component' },
	        _react2.default.createElement(
	          _antd.Collapse,
	          {
	            defaultActiveKey: keys
	          },
	          this.renderConditionGroups(),
	          this.renderTaskGroup()
	        )
	      );
	    }
	  }]);
	  return RuleBranch;
	}(_react2.default.Component), _class.propTypes = {
	  options: _propTypes2.default.shape({
	    actions: _propTypes2.default.shape({
	      ruleBranch: _propTypes2.default.shape({
	        remove: _propTypes2.default.func.isRequired,
	        update: _propTypes2.default.func.isRequired
	      }),
	      task: _propTypes2.default.shape(_Task2.default.propTypes.taskActions).isRequired,
	      conditionGroup: _propTypes2.default.shape(_ConditionGroup2.default.propTypes.conditionGroupActions),
	      condition: _propTypes2.default.shape(_ConditionGroup2.default.propTypes.conditionActions)
	    })
	  }).isRequired,
	  ruleBranch: _propTypes2.default.shape({
	    clauseIntro: _propTypes2.default.oneOf(['IF', 'ELSEIF', 'ELSE']).isRequired,
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    priority: _propTypes2.default.number.isRequired,
	    quantifier: _propTypes2.default.oneOf(['ALL', 'ANY']),
	    conditionGroups: _propTypes2.default.arrayOf(_ConditionGroup2.default.propTypes.conditionGroup),
	    tasks: _propTypes2.default.arrayOf(_Task2.default.propTypes.task)
	  }).isRequired,
	  users: _propTypes2.default.shape(_Task2.default.propTypes.users).isRequired,
	  editingConditions: _ConditionGroup2.default.propTypes.editingConditions,
	  editingTasks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).isRequired,
	  meta: _propTypes2.default.shape(_ConditionGroup2.default.propTypes.meta).isRequired,
	  ruleSettings: _propTypes2.default.shape(_Task2.default.propTypes.ruleSettings).isRequired,
	  invalidEntities: _propTypes2.default.shape({
	    ruleBranches: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	    conditionGroups: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	    conditions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	    tasks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))
	  }).isRequired,
	  builderActions: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	  editingConditions: [],
	  editingTasks: []
	}, _temp2);
	exports.default = RuleBranch;

/***/ },

/***/ 3782:
/***/ function(module, exports) {



/***/ },

/***/ 3783:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _Condition = __webpack_require__(3784);
	
	var _Condition2 = _interopRequireDefault(_Condition);
	
	__webpack_require__(3820);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var conditionGroupQuantifierLabels = {
	  ALL: _react2.default.createElement(_reactIntl.FormattedMessage, {
	    id: 'conditiongroup.quantifier.button.all',
	    defaultMessage: 'AND'
	  }),
	  ANY: _react2.default.createElement(_reactIntl.FormattedMessage, {
	    id: 'conditiongroup.quantifier.button.any',
	    defaultMessage: 'OR'
	  })
	};
	
	var ConditionGroup = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(ConditionGroup, _React$Component);
	
	  function ConditionGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ConditionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConditionGroup.__proto__ || (0, _getPrototypeOf2.default)(ConditionGroup)).call.apply(_ref, [this].concat(args))), _this), _this.updateConditionGroupQuantifier = function (id, ruleBranchID) {
	      return function (e) {
	        _this.props.conditionGroupActions.update(id, ruleBranchID, {
	          quantifier: e.target.value
	        });
	      };
	    }, _this.renderConditions = function () {
	      var _this$props = _this.props,
	          conditionGroup = _this$props.conditionGroup,
	          ruleBranchID = _this$props.ruleBranchID,
	          conditionActions = _this$props.conditionActions,
	          editingConditions = _this$props.editingConditions,
	          ruleSettings = _this$props.ruleSettings;
	
	      if (conditionGroup.conditions && conditionGroup.conditions.length) {
	        var quantifierLabel = _react2.default.createElement(
	          'div',
	          { className: 'condition-group-quantifier' },
	          conditionGroupQuantifierLabels[conditionGroup.quantifier]
	        );
	        return conditionGroup.conditions.map(function (condition, index) {
	          var editMode = editingConditions.includes(condition.id);
	          return _react2.default.createElement(
	            'div',
	            { key: 'condition-' + condition.id },
	            _react2.default.createElement(_Condition2.default, {
	              condition: condition,
	              conditionGroupID: conditionGroup.id,
	              ruleBranchID: ruleBranchID,
	              conditionActions: conditionActions,
	              meta: _this.props.meta,
	              editing: editMode,
	              builderActions: _this.props.builderActions,
	              ruleSettings: ruleSettings
	            }),
	            conditionGroup.conditions[index + 1] && quantifierLabel
	          );
	        });
	      }
	      return null;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ConditionGroup, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.editingConditions !== nextProps.editingConditions || this.props.conditionGroup !== nextProps.conditionGroup || this.props.meta !== nextProps.meta || this.props.ruleSettings !== nextProps.ruleSettings || this.state !== nextState;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          conditionGroup = _props.conditionGroup,
	          ruleBranchID = _props.ruleBranchID;
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'condition-group-' + conditionGroup.id, className: 'conditionGroup__component' },
	        _react2.default.createElement(
	          _antd.Row,
	          { className: 'condition-group-actions' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              RadioGroup,
	              {
	                onChange: this.updateConditionGroupQuantifier(conditionGroup.id, ruleBranchID),
	                value: conditionGroup.quantifier,
	                className: 'condition-group-quantifier-button'
	              },
	              _react2.default.createElement(
	                RadioButton,
	                { value: 'ALL' },
	                conditionGroupQuantifierLabels.ALL
	              ),
	              _react2.default.createElement(
	                RadioButton,
	                { value: 'ANY' },
	                conditionGroupQuantifierLabels.ANY
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Tooltip,
	              {
	                placement: 'top',
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'conditiongroup.quantifier.tooltip',
	                  defaultMessage: 'Choose how conditions in this group will be combined together'
	                })
	              },
	              _react2.default.createElement(_antd.Icon, { type: 'info-circle-o' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            this.renderConditions()
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                onClick: function onClick() {
	                  _this2.props.conditionActions.add(conditionGroup.id, ruleBranchID);
	                },
	                type: 'dashed',
	                className: 'add-condition-button',
	                size: 'small'
	              },
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'conditiongroup.add.condition.button',
	                defaultMessage: '+ Add Condition'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ConditionGroup;
	}(_react2.default.Component), _class.propTypes = {
	  conditionGroupActions: _propTypes2.default.shape({
	    update: _propTypes2.default.func.isRequired
	  }).isRequired,
	  conditionActions: _propTypes2.default.shape(_Condition2.default.propTypes.conditionActions).isRequired,
	  conditionGroup: _propTypes2.default.shape({
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	    quantifier: _propTypes2.default.oneOf(['ALL', 'ANY']).isRequired,
	    conditions: _propTypes2.default.arrayOf(_Condition2.default.propTypes.condition)
	  }),
	  ruleBranchID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  editingConditions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).isRequired,
	  meta: _propTypes2.default.shape(_Condition2.default.propTypes.meta).isRequired,
	  builderActions: _propTypes2.default.func.isRequired,
	  ruleSettings: _propTypes2.default.shape(_Condition2.default.propTypes.ruleSettings).isRequired
	}, _class.defaultProps = {
	  conditionGroup: {}
	}, _temp2);
	exports.default = ConditionGroup;

/***/ },

/***/ 3784:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(783);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _immutabilityHelper = __webpack_require__(1644);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _selectors = __webpack_require__(3610);
	
	var _helpers = __webpack_require__(3608);
	
	var _ValidationInputs = __webpack_require__(3785);
	
	var _ValidationInputs2 = _interopRequireDefault(_ValidationInputs);
	
	__webpack_require__(3791);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var find = __webpack_require__(3792);
	
	var Condition = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(Condition, _React$Component);
	
	  function Condition() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Condition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Condition.__proto__ || (0, _getPrototypeOf2.default)(Condition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      form: {
	        fact: null,
	        operator: null,
	        value: {
	          valueJson: null,
	          valueDecimal: null,
	          valueString: null
	        }
	      }
	    }, _this.isFormValid = function () {
	      if (typeof _this.state.isValid !== 'undefined') return _this.state.isValid;
	      return (0, _helpers.isConditionValid)(_this.state.form);
	    }, _this.onFactChange = function (value) {
	      var newState = (0, _assign2.default)({}, _this.state);
	      newState.form = {
	        fact: value[2],
	        operator: null,
	        valueJson: null,
	        valueString: null,
	        valueDecimal: null
	      };
	      newState.isValid = null;
	      _this.setState(newState);
	    }, _this.onOperatorChange = function (item) {
	      var newState = (0, _assign2.default)({}, _this.state);
	      newState.form.operator = item.key;
	      _this.setState(newState);
	    }, _this.cancelSaveCondition = function () {
	      var _this$props = _this.props,
	          conditionActions = _this$props.conditionActions,
	          condition = _this$props.condition,
	          conditionGroupID = _this$props.conditionGroupID,
	          ruleBranchID = _this$props.ruleBranchID;
	      var id = condition.id,
	          fact = condition.fact,
	          operator = condition.operator,
	          valueJson = condition.valueJson,
	          valueDecimal = condition.valueDecimal,
	          valueString = condition.valueString;
	      // existing condition
	
	      _this.updateValidationInputsValidation(true);
	      if ((0, _helpers.isConditionValid)(condition)) {
	        _this.setState({
	          form: {
	            fact: fact,
	            operator: operator,
	            valueJson: valueJson,
	            valueDecimal: valueDecimal,
	            valueString: valueString
	          }
	        }, function () {
	          conditionActions.cancelEdit(id);
	        });
	      } else {
	        conditionActions.remove(condition.id, conditionGroupID, ruleBranchID);
	      }
	    }, _this.saveCondition = function () {
	      var _this$props2 = _this.props,
	          condition = _this$props2.condition,
	          conditionActions = _this$props2.conditionActions,
	          conditionGroupID = _this$props2.conditionGroupID,
	          ruleBranchID = _this$props2.ruleBranchID;
	
	      var form = (0, _assign2.default)({}, _this.state.form);
	      conditionActions.cancelEdit(condition.id);
	      conditionActions.update(condition.id, conditionGroupID, ruleBranchID, {
	        fact: form.fact,
	        operator: form.operator,
	        valueJson: form.valueJson,
	        valueDecimal: form.valueDecimal,
	        valueString: form.valueString
	      });
	    }, _this.onValidationInputsChange = function (parent) {
	      var parseValues = function parseValues(values) {
	        var parsed = (0, _assign2.default)({}, values);
	        if (values.location) {
	          parsed.loc = parseInt(values.location.key, 10);
	          parsed.locLabel = values.location.label;
	        }
	        delete parsed.location;
	        return parsed;
	      };
	
	      if (parent) {
	        return function (values) {
	          var parsedValues = parseValues(values);
	          var opType = _this.state.form[parent] ? '$merge' : '$set';
	          _this.setState({ form: (0, _immutabilityHelper2.default)(_this.state.form, (0, _defineProperty3.default)({}, parent, (0, _defineProperty3.default)({}, opType, parsedValues))) });
	        };
	      }
	      return function (values) {
	        var parsedValues = parseValues(values);
	        _this.setState({ form: (0, _immutabilityHelper2.default)(_this.state.form, {
	            $merge: parsedValues
	          }) });
	      };
	    }, _this.updateValidationInputsValidation = function (isValid, updateStore) {
	      var _this$props3 = _this.props,
	          ruleBranchID = _this$props3.ruleBranchID,
	          conditionGroupID = _this$props3.conditionGroupID,
	          condition = _this$props3.condition,
	          builderActions = _this$props3.builderActions;
	
	      _this.setState({ isValid: isValid }, function () {
	        if (updateStore === true) {
	          builderActions('updateEntitiesValidation', {
	            ruleBranches: ruleBranchID,
	            conditionGroups: conditionGroupID,
	            conditions: condition.id
	          }, isValid);
	        }
	      });
	    }, _this.renderOperatorsMenu = function (opType) {
	      var operators = _this.props.meta.operators.data[opType];
	      var defaultSelectedKeys = _this.state.form.operator ? [_this.state.form.operator] : [];
	      var menuItems = operators.map(function (operator, index) {
	        return _react2.default.createElement(
	          _antd.Menu.Item,
	          { key: operator.value, value: operator.value },
	          operator.label
	        );
	      });
	
	      return _react2.default.createElement(
	        _antd.Menu,
	        { onClick: _this.onOperatorChange, defaultSelectedKeys: defaultSelectedKeys },
	        menuItems
	      );
	    }, _this.editView = function () {
	      var fact = _this.state.form.fact;
	      var meta = _this.props.meta;
	
	      var triggersLoading = meta.loading ? { hasFeedback: true, validateStatus: "validating", disabled: true } : {};
	
	      /**
	       * On init, the component hydrates its local state's
	       * values with the condition data (trigger, operator, etc). This
	       * provides ease-of-use since we just need to track changes made
	       * to the local state and run validation on those values.
	       * Due to the backend response structure, when loading a condition
	       * from backend, we are provided with unique IDs for the condition
	       * data. In the case of trigger selection (cascader ant component)
	       * during edit, we need to build the array which will be used as
	       * defaultValue for cascader in order to populate the loaded
	       * trigger from the backend.
	       */
	      var cascaderDefaultValue = [];
	      var triggerEntity = {};
	
	      /**
	       * If the local state's form trigger value is valid, build out
	       * the defaultValue which will be used by cascader. While doing
	       * this, we also obtain the actual trigger object, which will be
	       * needed for operator selection.
	       */
	      if (_this.state.form.fact) {
	        cascaderDefaultValue = (0, _helpers.getCascaderPathToEntityBy)('alias', fact, meta.cascaderTriggersOptions, true);
	        triggerEntity = cascaderDefaultValue[2];
	        cascaderDefaultValue[2] = fact;
	      } else {
	        cascaderDefaultValue = [];
	      }
	
	      var factMarkup = _react2.default.createElement(_antd.Cascader, {
	        disabled: triggersLoading.disabled,
	        options: meta.cascaderTriggersOptions,
	        onChange: _this.onFactChange,
	        placeholder: 'Search or select trigger',
	        defaultValue: cascaderDefaultValue,
	        style: { width: '100%' },
	        displayRender: function displayRender(label) {
	          return label[2];
	        },
	        showSearch: {
	          filter: function filter(inputValue, path) {
	            return path.some(function (option) {
	              return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
	            });
	          },
	          matchInputWidth: false
	        }
	      });
	
	      /**
	       * Let's render the operator field markup only if the fact
	       * field is valid.
	       */
	      var operatorMarkup = void 0;
	      if (_this.state.form.fact) {
	        var operator = _this.state.form.operator;
	
	        var operatorObject = void 0;
	        var selectLabel = void 0;
	        var _triggerEntity = triggerEntity,
	            filterOpType = _triggerEntity.filterOpType;
	
	        if (_this.state.form.operator) {
	          operatorObject = find(_this.props.meta.operators.data[filterOpType], { value: operator });
	          selectLabel = operatorObject.label;
	        } else {
	          selectLabel = 'select';
	        }
	        var operatorMenu = _this.renderOperatorsMenu(filterOpType);
	        operatorMarkup = _react2.default.createElement(
	          _antd.Dropdown,
	          { overlay: operatorMenu, key: _this.state.form.fact + '-operator', trigger: ['click'], getPopupContainer: _this.getPopupContainer },
	          _react2.default.createElement(
	            'a',
	            { className: 'ant-dropdown-link' },
	            selectLabel,
	            ' ',
	            _react2.default.createElement(_antd.Icon, { type: 'down' })
	          )
	        );
	      }
	
	      /**
	       * Let's render the value field markup only if the operator
	       * field is valid.
	       */
	      var valueMarkup = void 0;
	      var fieldsConfig = void 0;
	      if (_this.state.form.operator) {
	        var _triggerEntity2 = triggerEntity,
	            format = _triggerEntity2.format,
	            supportedUnits = _triggerEntity2.supportedUnits,
	            supportedValues = _triggerEntity2.supportedValues,
	            valueField = _triggerEntity2.valueField,
	            additionalFields = _triggerEntity2.additionalFields;
	        /**
	         * If the valueField is valueDecimal, valueString, or valueTime,
	         * the read/writing to the field is straightforward since
	         * we are only going to be dealing with one field for the data.
	         */
	
	        if (valueField === 'valueDecimal' || valueField === 'valueString') {
	          fieldsConfig = [{
	            name: valueField,
	            format: format,
	            children: supportedValues,
	            decorator: {
	              rules: [{ required: true, message: 'Missing value' }],
	              initialValue: _this.state.form[valueField] ? _this.state.form[valueField] : null
	            }
	          }];
	
	          if (format === "integer" || format === "decimal" || format === "currency" || format === "percent" || format === "numeric") {
	            fieldsConfig[0].decorator.type = 'number';
	            fieldsConfig[0].decorator.initialValue = _this.state.form[valueField] !== null ? parseFloat(_this.state.form[valueField]) : null;
	          }
	        } else {
	          /**
	           * On the other hand, if valueField is valueJson, this
	           * is an indication that we have multiple data/form fields
	           * that make up the entire value. For this, let's loop
	           * over the different fields and render out the markup.
	           *
	           * For the interim, backend doesn't support sending FE
	           * the schema of the actual valueJson field, so we will
	           * maintain a mapping of valueJson schemas depending on
	           * the trigger 'grouping'.
	           *
	           * Besides building out our main 'value' field, we will
	           * check if there are supportedUnits. If there are,
	           * this is an indication that there needs to be
	           * a buddy unit field. ANT requires different markup than
	           * the addonBefore/addonAfter prop for the form elements for
	           * what we're trying to achieve, so we'll build that
	           * out in accordance.
	           */
	          fieldsConfig = [{
	            name: 'value',
	            format: format,
	            children: supportedValues,
	            decorator: {
	              rules: [{ required: true, message: 'Missing value' }]
	            },
	            buddy: supportedUnits && supportedUnits.length > 0 ? {
	              name: 'unit',
	              format: 'select',
	              children: supportedUnits,
	              decorator: {
	                rules: [{ required: true, message: 'Missing unit' }]
	              }
	            } : null
	          }];
	
	          if (_this.state.form.valueJson && _this.state.form.valueJson.value) {
	            fieldsConfig[0].decorator.initialValue = _this.state.form.valueJson.value;
	          }
	
	          if (_this.state.form.valueJson && _this.state.form.valueJson.unit) {
	            fieldsConfig[0].buddy.decorator.initialValue = _this.state.form.valueJson.unit;
	          }
	
	          if (additionalFields && additionalFields.length > 0) {
	            additionalFields.forEach(function (field, index) {
	              if (field.format === 'location-lookup') {
	                fieldsConfig.push({
	                  name: 'location',
	                  format: 'location-lookup',
	                  options: {
	                    fetchLocationsAction: _this.props.conditionActions.fetchLocations
	                  },
	                  formItem: {
	                    label: 'in'
	                  },
	                  decorator: {
	                    rules: [{ required: true, message: 'Missing location' }],
	                    initialValue: _this.state.form.valueJson && _this.state.form.valueJson.loc && _this.state.form.valueJson.locLabel ? {
	                      key: _this.state.form.valueJson.loc.toString(),
	                      label: _this.state.form.valueJson.locLabel
	                    } : { key: '', label: null }
	                  }
	                });
	              }
	            });
	          }
	        }
	
	        valueMarkup = _react2.default.createElement(_ValidationInputs2.default, {
	          fields: fieldsConfig,
	          onChange: _this.onValidationInputsChange(valueField === "valueJson" ? "valueJson" : null),
	          isValid: _this.updateValidationInputsValidation
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-condition' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 20 },
	            _react2.default.createElement(
	              _antd.Row,
	              { type: 'flex', justify: 'start' },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 5, className: 'm-r-16' },
	                _react2.default.createElement(
	                  FormItem,
	                  triggersLoading,
	                  factMarkup
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { className: 'text-align-center m-r-16' },
	                _react2.default.createElement(
	                  FormItem,
	                  null,
	                  operatorMarkup
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                valueMarkup
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, className: 'text-align-right' },
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                onClick: function onClick() {
	                  return _this.saveCondition();
	                },
	                type: 'primary',
	                className: 'condition-save-button',
	                disabled: !_this.isFormValid()
	              },
	              _react2.default.createElement(_antd.Icon, { type: 'check' })
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                onClick: function onClick() {
	                  return _this.cancelSaveCondition();
	                },
	                type: 'default',
	                className: 'condition-cancel-save-button'
	              },
	              _react2.default.createElement(_antd.Icon, { type: 'close' })
	            )
	          )
	        )
	      );
	    }, _this.readOnlyView = function () {
	      var _this$props4 = _this.props,
	          condition = _this$props4.condition,
	          meta = _this$props4.meta,
	          conditionActions = _this$props4.conditionActions,
	          conditionGroupID = _this$props4.conditionGroupID,
	          ruleBranchID = _this$props4.ruleBranchID;
	      var operators = meta.operators,
	          triggers = meta.triggers;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'read-only-condition' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 20, className: 'show-white-space' },
	            (0, _selectors.conditionDescriptionBuilder)({ condition: condition, operators: operators, triggers: triggers })
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, className: 'text-align-right' },
	            _react2.default.createElement(_antd.Button, {
	              icon: 'edit',
	              size: 'large',
	              className: 'condition-edit-button',
	              onClick: function onClick() {
	                conditionActions.edit(condition.id);
	              }
	            }),
	            _react2.default.createElement(_antd.Button, {
	              icon: 'close',
	              size: 'large',
	              className: 'condition-remove-button',
	              onClick: function onClick() {
	                conditionActions.remove(condition.id, conditionGroupID, ruleBranchID);
	              }
	            })
	          )
	        )
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Condition, [{
	    key: 'componentWillMount',
	
	
	    /**
	     * When a Condition is initialized, we pass the data to its
	     * state. If the condition data is invalid, it will immediately
	     * dispatch an action to "edit" it. This is done so that when
	     * we do pass in valid data, it should be rendered as read-only.
	     */
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          conditionActions = _props.conditionActions,
	          condition = _props.condition;
	      var id = condition.id,
	          fact = condition.fact,
	          operator = condition.operator,
	          valueJson = condition.valueJson,
	          valueDecimal = condition.valueDecimal,
	          valueString = condition.valueString;
	
	
	      this.setState({
	        form: {
	          fact: fact,
	          operator: operator,
	          valueJson: valueJson,
	          valueDecimal: valueDecimal,
	          valueString: valueString
	        }
	      }, function () {
	        // dispatch edit for this condition if the form is invalid
	        if (!_this2.isFormValid()) {
	          conditionActions.edit(id);
	        }
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.editing !== nextProps.editing || this.props.condition !== nextProps.condition || this.props.meta !== nextProps.meta || this.props.ruleSettings !== nextProps.ruleSettings || this.state !== nextState;
	    }
	
	    /**
	     * We check if the form is valid here.
	     * The condition is considered valid if there is a presence of
	     * fact, operator and (valueDecimal OR valueString OR valueJson (needs to not be empty)).
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          editing = _props2.editing,
	          ruleSettings = _props2.ruleSettings;
	      var fact = this.state.form.fact;
	
	      var conditionRender = editing ? this.editView() : this.readOnlyView();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'condition__component' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          conditionRender
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          (0, _helpers.getConditionRestrictionMessage)(ruleSettings, fact)
	        )
	      );
	    }
	  }]);
	  return Condition;
	}(_react2.default.Component), _class.propTypes = {
	  condition: _propTypes2.default.shape({
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    fact: _propTypes2.default.string,
	    operator: _propTypes2.default.string,
	    valueJson: _propTypes2.default.object,
	    valueString: _propTypes2.default.string,
	    valueDecimal: _propTypes2.default.number
	  }).isRequired,
	  conditionActions: _propTypes2.default.shape({
	    edit: _propTypes2.default.func.isRequired,
	    cancelEdit: _propTypes2.default.func.isRequired,
	    update: _propTypes2.default.func.isRequired,
	    remove: _propTypes2.default.func.isRequired,
	    fetchLocations: _propTypes2.default.func.isRequired
	  }).isRequired,
	  conditionGroupID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  ruleBranchID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  editing: _propTypes2.default.bool,
	  meta: _propTypes2.default.shape({
	    triggers: _propTypes2.default.shape({
	      data: _propTypes2.default.objectOf(_propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
	        alias: _propTypes2.default.string.isRequired
	      })))).isRequired
	    }).isRequired,
	    operators: _propTypes2.default.shape({
	      data: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired
	      }))).isRequired
	    }).isRequired,
	    cascaderTriggersOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      value: _propTypes2.default.string.isRequired,
	      label: _propTypes2.default.string.isRequired,
	      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired,
	        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	          value: _propTypes2.default.string.isRequired,
	          label: _propTypes2.default.string.isRequired
	        }))
	      }))
	    })),
	    loading: _propTypes2.default.bool.isRequired,
	    error: _propTypes2.default.string
	  }).isRequired,
	  builderActions: _propTypes2.default.func.isRequired,
	  ruleSettings: _propTypes2.default.shape({
	    aggregationLevel: _propTypes2.default.oneOf(['FB_CAMPAIGN', 'FB_ADSET', 'FB_AD']),
	    dataRangeRelative: _propTypes2.default.string,
	    dataRangeAbsoluteStart: _propTypes2.default.string,
	    dataRangeAbsoluteEnd: _propTypes2.default.string,
	    lastNDays: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	  }).isRequired
	}, _class.defaultProps = {
	  editing: false
	}, _temp2);
	exports.default = Condition;

/***/ },

/***/ 3785:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1667);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _helpers = __webpack_require__(3608);
	
	__webpack_require__(3786);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var InputGroup = _antd.Input.Group;
	var debounce = __webpack_require__(3787);
	var delay = __webpack_require__(3789);
	
	var nothingFoundLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
	  id: 'validationInputs.location.lookup.no.results.label',
	  defaultMessage: 'Nothing found...'
	});
	
	var ValidationInputs = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(ValidationInputs, _Component);
	
	  function ValidationInputs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ValidationInputs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ValidationInputs.__proto__ || (0, _getPrototypeOf2.default)(ValidationInputs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      locations: {
	        data: [],
	        loading: false,
	        error: null,
	        query: null
	      },
	      isValid: null
	    }, _this.getValueField = function (format) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var name = arguments[4];
	
	      var fieldMarkup = void 0;
	      var formItemProps = void 0;
	      switch (format) {
	        case 'checkbox':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('checkbox', (0, _extends3.default)({}, props, {
	              onChange: function onChange() {
	                _this.checkValidation([name]);
	              }
	            }), children);
	            break;
	          }
	        case 'percent':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('input-number', (0, _extends3.default)({}, props, {
	              formatter: function formatter(value) {
	                return '% ' + (0, _helpers.numberMask)(value);
	              },
	              parser: function parser(value) {
	                return value.replace(/%\s?|(,*)/g, '');
	              },
	              onKeyUp: function onKeyUp() {
	                _this.checkValidation([name]);
	              },
	              onChange: function onChange() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              style: {
	                width: 80
	              }
	            }));
	            break;
	          }
	        case 'currency':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('input-number', (0, _extends3.default)({}, props, {
	              formatter: function formatter(value) {
	                return '$ ' + (0, _helpers.numberMask)(value);
	              },
	              parser: function parser(value) {
	                return value.replace(/\$\s?|(,*)/g, '');
	              },
	              onKeyUp: function onKeyUp() {
	                _this.checkValidation([name]);
	              },
	              onChange: function onChange() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              style: {
	                width: 100
	              }
	            }));
	            break;
	          }
	        case 'decimal':
	        case 'numeric':
	        case 'integer':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('input-number', (0, _extends3.default)({}, props, {
	              onKeyUp: function onKeyUp() {
	                _this.checkValidation([name]);
	              },
	              onChange: function onChange() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              style: {
	                width: 80
	              }
	            }));
	            break;
	          }
	        case 'multiselect':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('select', (0, _extends3.default)({}, props, {
	              mode: 'multiple',
	              filterOption: function filterOption(input, option) {
	                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	              },
	              onSelect: function onSelect() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              onChange: function onChange() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              dropdownMatchSelectWidth: false
	            }), children);
	            break;
	          }
	        case 'select':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('select', (0, _extends3.default)({}, props, {
	              filterOption: function filterOption(input, option) {
	                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	              },
	              onSelect: function onSelect() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              onChange: function onChange() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              dropdownMatchSelectWidth: false
	            }), children);
	            break;
	          }
	        case 'location-lookup':
	          {
	            formItemProps = {
	              hasFeedback: _this.state.locations.loading === true,
	              validateStatus: _this.state.locations.loading === true ? "validating" : null
	            };
	
	            var _children = _this.state.locations.data.map(function (location) {
	              return {
	                label: location.city_name + ', ' + location.state_abbr + ', ' + location.country_abbr,
	                value: '' + location.id
	              };
	            });
	
	            var debouncedFetchLocations = debounce(function (value) {
	              options.fetchLocationsAction(value, function (data) {
	                _this.setState({
	                  locations: (0, _assign2.default)({}, _this.state.locations, {
	                    data: data,
	                    error: null,
	                    loading: false
	                  })
	                });
	              }, function (err) {
	                _this.setState({
	                  locations: (0, _assign2.default)({}, _this.state.locations, {
	                    data: [],
	                    error: err,
	                    loading: false
	                  })
	                });
	              });
	            }, 250, {
	              leading: false,
	              trailing: true
	            });
	
	            fieldMarkup = (0, _helpers.getFieldByType)('select', (0, _extends3.default)({}, props, {
	              notFoundContent: _this.state.locations.data.length === 0 && _this.state.locations.query ? nothingFoundLabel : false,
	              onSearch: function onSearch(value) {
	                if (value) {
	                  _this.setState({
	                    locations: (0, _assign2.default)({}, _this.state.locations, {
	                      error: null,
	                      loading: true,
	                      query: value
	                    })
	                  });
	                  debouncedFetchLocations(value);
	                }
	              },
	              filterOption: false,
	              allowClear: false,
	              optionFilterProp: 'value',
	              optionLabelProp: 'label',
	              showSearch: true,
	              labelInValue: true,
	              onSelect: function onSelect() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              onChange: function onChange() {
	                delay(_this.checkValidation, 50, [name]);
	              },
	              dropdownMatchSelectWidth: false
	            }), _children);
	            break;
	          }
	        case 'string':
	          {
	            fieldMarkup = (0, _helpers.getFieldByType)('input', (0, _extends3.default)({}, props, {
	              onKeyUp: function onKeyUp() {
	                _this.checkValidation([name]);
	              }
	            }));
	            break;
	          }
	        default:
	          break;
	      }
	      return {
	        formItemProps: formItemProps,
	        element: fieldMarkup
	      };
	    }, _this.getRequiredFields = function (fields) {
	      var requiredFields = [];
	      fields.forEach(function (field) {
	        if (field.decorator && field.decorator.rules && field.decorator.rules.length && field.decorator.rules[0].required) {
	          requiredFields.push(field.name);
	        }
	        if (field.buddy && field.buddy.decorator && field.buddy.decorator.rules && field.buddy.decorator.rules.length && field.buddy.decorator.rules[0].required) {
	          requiredFields.push(field.buddy.name);
	        }
	      });
	      return requiredFields;
	    }, _this.checkRequiredFieldsValue = function () {
	      var _this$props = _this.props,
	          form = _this$props.form,
	          fields = _this$props.fields;
	
	      var requiredFields = _this.getRequiredFields(fields);
	      var isValid = true;
	      requiredFields.forEach(function (requiredFieldName) {
	        var fieldTrueValue = form.getFieldValue(requiredFieldName);
	        var parsedValue = void 0;
	        if (requiredFieldName === 'location') {
	          parsedValue = fieldTrueValue.key !== '' ? fieldTrueValue : null;
	        } else {
	          parsedValue = fieldTrueValue;
	        }
	        if (typeof parsedValue === 'undefined' || parsedValue === null) {
	          isValid = false;
	        }
	      });
	
	      if (isValid) {
	        _this.props.isValid(true, true);
	      } else {
	        _this.props.isValid(false, false);
	      }
	    }, _this.checkValidation = function (fields) {
	      var isValid = true;
	      _this.props.form.validateFields(fields, function (error, value) {
	        if (error) {
	          isValid = false;
	        }
	      });
	
	      if (isValid) {
	        _this.checkRequiredFieldsValue();
	      } else {
	        _this.props.isValid(false, true);
	      }
	    }, _this.renderFields = function (fields) {
	      if (fields && fields.length) {
	        var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	        return fields.map(function (fieldObject) {
	          var mainField = _this.getValueField(fieldObject.format, (0, _extends3.default)({}, fieldObject.props), fieldObject.children, fieldObject.options, fieldObject.name);
	          var fieldRender = void 0;
	          if (fieldObject.buddy) {
	            var buddyField = _this.getValueField(fieldObject.buddy.format, (0, _extends3.default)({}, fieldObject.buddy.props, {
	              style: {
	                width: 80
	              }
	            }), fieldObject.buddy.children, fieldObject.buddy.options, fieldObject.buddy.name);
	            fieldRender = _react2.default.createElement(
	              InputGroup,
	              { compact: true, className: 'input-with-buddy suffixed', key: 'buddy-field' },
	              getFieldDecorator(fieldObject.name, (0, _extends3.default)({}, fieldObject.decorator, { validateTrigger: false }))(mainField.element),
	              getFieldDecorator(fieldObject.buddy.name, (0, _extends3.default)({}, fieldObject.buddy.decorator, { validateTrigger: false }))(buddyField.element)
	            );
	          } else {
	            fieldRender = getFieldDecorator(fieldObject.name, (0, _extends3.default)({}, fieldObject.decorator, { validateTrigger: false }))(mainField.element);
	          }
	
	          return _react2.default.createElement(
	            FormItem,
	            (0, _extends3.default)({}, fieldObject.formItem, {
	              colon: false,
	              className: 'warning-field'
	            }, mainField.formItemProps, {
	              key: fieldObject.id ? fieldObject.id : fieldObject.name
	            }),
	            fieldRender
	          );
	        });
	      }
	      return null;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ValidationInputs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.for !== nextProps.for) {
	        this.props.form.resetFields();
	        this.props.isValid(false, false);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.for !== nextProps.for || this.props.form !== nextProps.form || this.props.fields !== nextProps.fields || this.state !== nextState;
	    }
	
	    /**
	     * This method is responsible for maintaining a collection
	     * different types of fields required by FE to i/o the data
	     * required by BE dynamically, essentially based on the
	     * 'format' field of a trigger. We pass in the field's
	     * parentValueEntity and valueEntity props in order to
	     * map the corresponding fields in our local form state,
	     * along with the defaultValue and any suggestedOptions
	     * (for Select elements).
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'validationInputs__component' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', hideRequiredMark: true },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            this.renderFields(this.props.fields)
	          )
	        )
	      );
	    }
	  }]);
	  return ValidationInputs;
	}(_react.Component), _class.propTypes = {
	  form: _propTypes2.default.shape({
	    getFieldDecorator: _propTypes2.default.func.isRequired,
	    getFieldsError: _propTypes2.default.func.isRequired,
	    validateFields: _propTypes2.default.func.isRequired,
	    resetFields: _propTypes2.default.func.isRequired,
	    setFields: _propTypes2.default.func.isRequired
	  }).isRequired,
	  for: _propTypes2.default.string,
	  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    format: _propTypes2.default.oneOf(['percent', 'checkbox', 'currency', 'decimal', 'tags', 'numeric', 'integer', 'multiselect', 'select', 'location-lookup', 'string']).isRequired,
	    children: _propTypes2.default.arrayOf(_propTypes2.default.any),
	    options: _propTypes2.default.object,
	    formItem: _propTypes2.default.shape({
	      label: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
	    }),
	    decorator: _propTypes2.default.shape({
	      rules: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        required: _propTypes2.default.bool,
	        message: _propTypes2.default.string
	      })),
	      initialValue: _propTypes2.default.any
	    })
	  })),
	  isValid: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	  fields: [],
	  for: 'validation-inputs-form'
	}, _temp2);
	exports.default = _antd.Form.create({
	  onFieldsChange: function onFieldsChange(props, fields) {
	    var updates = {};
	    (0, _keys2.default)(fields).forEach(function (fieldName) {
	      updates[fieldName] = fields[fieldName].value;
	    });
	    props.onChange(updates);
	  }
	})(ValidationInputs);

/***/ },

/***/ 3786:
/***/ function(module, exports) {



/***/ },

/***/ 3787:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3602),
	    now = __webpack_require__(3788);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed invocations. Provide an options object to indicate that `func`
	 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	 * Subsequent calls to the debounced function return the result of the last
	 * `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it is invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },

/***/ 3788:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(3599);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	module.exports = now;


/***/ },

/***/ 3789:
/***/ function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(3790),
	    restParam = __webpack_require__(3625);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it is invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke the function with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => logs 'later' after one second
	 */
	var delay = restParam(function(func, wait, args) {
	  return baseDelay(func, wait, args);
	});
	
	module.exports = delay;


/***/ },

/***/ 3790:
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts an index
	 * of where to slice the arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Object} args The arguments provide to `func`.
	 * @returns {number} Returns the timer id.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ },

/***/ 3791:
/***/ function(module, exports) {



/***/ },

/***/ 3792:
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(3793),
	    createFind = __webpack_require__(3796);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ },

/***/ 3793:
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(3794),
	    createBaseEach = __webpack_require__(3795);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },

/***/ 3794:
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(3774),
	    keys = __webpack_require__(3604);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },

/***/ 3795:
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(3594),
	    isLength = __webpack_require__(3596),
	    toObject = __webpack_require__(3776);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },

/***/ 3796:
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(3797),
	    baseFind = __webpack_require__(3818),
	    baseFindIndex = __webpack_require__(3819),
	    isArray = __webpack_require__(3598);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ },

/***/ 3797:
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(3798),
	    baseMatchesProperty = __webpack_require__(3810),
	    bindCallback = __webpack_require__(3778),
	    identity = __webpack_require__(3779),
	    property = __webpack_require__(3816);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },

/***/ 3798:
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(3799),
	    getMatchData = __webpack_require__(3807),
	    toObject = __webpack_require__(3776);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },

/***/ 3799:
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(3800),
	    toObject = __webpack_require__(3776);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },

/***/ 3800:
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(3801),
	    isObject = __webpack_require__(3602),
	    isObjectLike = __webpack_require__(3597);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },

/***/ 3801:
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(3802),
	    equalByTag = __webpack_require__(3804),
	    equalObjects = __webpack_require__(3805),
	    isArray = __webpack_require__(3598),
	    isTypedArray = __webpack_require__(3806);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },

/***/ 3802:
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(3803);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },

/***/ 3803:
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },

/***/ 3804:
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },

/***/ 3805:
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(3604);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },

/***/ 3806:
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(3596),
	    isObjectLike = __webpack_require__(3597);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },

/***/ 3807:
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(3808),
	    pairs = __webpack_require__(3809);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },

/***/ 3808:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3602);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },

/***/ 3809:
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(3604),
	    toObject = __webpack_require__(3776);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },

/***/ 3810:
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(3811),
	    baseIsEqual = __webpack_require__(3800),
	    baseSlice = __webpack_require__(3812),
	    isArray = __webpack_require__(3598),
	    isKey = __webpack_require__(3813),
	    isStrictComparable = __webpack_require__(3808),
	    last = __webpack_require__(3814),
	    toObject = __webpack_require__(3776),
	    toPath = __webpack_require__(3815);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },

/***/ 3811:
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(3776);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },

/***/ 3812:
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },

/***/ 3813:
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(3598),
	    toObject = __webpack_require__(3776);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },

/***/ 3814:
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },

/***/ 3815:
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(3685),
	    isArray = __webpack_require__(3598);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },

/***/ 3816:
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(3595),
	    basePropertyDeep = __webpack_require__(3817),
	    isKey = __webpack_require__(3813);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },

/***/ 3817:
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(3811),
	    toPath = __webpack_require__(3815);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },

/***/ 3818:
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },

/***/ 3819:
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },

/***/ 3820:
/***/ function(module, exports) {



/***/ },

/***/ 3821:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _immutabilityHelper = __webpack_require__(1644);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _selectors = __webpack_require__(3610);
	
	var _helpers = __webpack_require__(3608);
	
	var _constants = __webpack_require__(3609);
	
	var _ValidationInputs = __webpack_require__(3785);
	
	var _ValidationInputs2 = _interopRequireDefault(_ValidationInputs);
	
	__webpack_require__(3822);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var find = __webpack_require__(3792);
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Task = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(Task, _React$Component);
	
	  function Task() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Task);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Task.__proto__ || (0, _getPrototypeOf2.default)(Task)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      form: {}
	    }, _this.getConditionalHelperText = function (action) {
	      var helperText = void 0;
	      switch (action) {
	        case 'CHANGE_BID':
	          {
	            var aggregationLevel = _this.props.ruleSettings.aggregationLevel;
	
	            var foundAggregationLevel = _constants.AGGREGATION_LEVELS.find(function (aggregationLevelObject) {
	              return aggregationLevelObject.value === aggregationLevel;
	            });
	            if (foundAggregationLevel) {
	              if (_this.state.form.actionValueFlag === 'INCREASE') {
	                helperText = _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.bid.increase.helper.text',
	                  defaultMessage: 'Bid increases will not be applied to {aggregationLevel} that uses auto bidding.',
	                  values: { aggregationLevel: foundAggregationLevel.label }
	                });
	              } else if (_this.state.form.actionValueFlag === 'DECREASE') {
	                helperText = _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.bid.decrease.helper.text',
	                  defaultMessage: 'Bid decreases will not be applied to {aggregationLevel} that uses auto bidding.',
	                  values: { aggregationLevel: foundAggregationLevel.label }
	                });
	              }
	            }
	            break;
	          }
	        default:
	          break;
	      }
	      return helperText;
	    }, _this.actionChange = function (value) {
	      var _this$props = _this.props,
	          ruleBranchID = _this$props.ruleBranchID,
	          task = _this$props.task,
	          builderActions = _this$props.builderActions;
	
	
	      var newFormState = {
	        action: value,
	        actionValue: null,
	        actionValueBound: null,
	        actionValueUnit: null,
	        actionValueFlag: null
	      };
	      _this.setState({
	        form: newFormState,
	        isValid: null
	      }, function () {
	        builderActions('updateEntitiesValidation', {
	          ruleBranches: ruleBranchID,
	          tasks: task.id
	        }, true);
	      });
	    }, _this.getFieldsForAction = function (action) {
	      if (!action) return null;
	      var fields = [];
	      switch (action) {
	        case 'CHANGE_STATE':
	          {
	            fields = [{
	              id: 'change_state',
	              name: 'actionValue',
	              format: 'select',
	              children: [{
	                value: 'ACTIVE',
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.change.status.dropdown.option.active.label',
	                  defaultMessage: 'Active'
	                })
	              }, {
	                value: 'PAUSED',
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.change.status.dropdown.option.pause.label',
	                  defaultMessage: 'Pause'
	                })
	              }],
	              decorator: {
	                rules: [{
	                  required: true,
	                  message: 'Missing value'
	                }],
	                initialValue: _this.state.form.actionValue
	              }
	            }];
	            if (_this.state.form.actionValue === 'ACTIVE') {
	              fields.push({
	                id: 'manual_override',
	                name: 'actionValueFlag',
	                format: 'checkbox',
	                props: {
	                  defaultChecked: _this.state.form.actionValueFlag && _this.state.form.actionValueFlag === 'MANUAL'
	                },
	                children: [_react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.manualOverride.label',
	                  key: 'manual-override-label',
	                  defaultMessage: 'Manual override '
	                }), _react2.default.createElement(
	                  _antd.Tooltip,
	                  {
	                    key: 'manual-override-tooltip',
	                    placement: 'top',
	                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                      id: 'task.manualOverride.tooltip',
	                      defaultMessage: 'Enable permission to activate entities which have been manually paused by a user (i.e., to override the manually applied status).'
	                    })
	                  },
	                  _react2.default.createElement(_antd.Icon, { type: 'question-circle-o' })
	                )]
	              });
	            }
	            break;
	          }
	        case 'CHANGE_BUDGET':
	        case 'CHANGE_BID':
	          {
	            var currentActionValueFlagValue = _this.state.form.actionValueFlag;
	            fields = [{
	              id: 'change_bid_type',
	              name: 'actionValueFlag',
	              format: 'select',
	              decorator: {
	                initialValue: _this.state.form.actionValueFlag,
	                rules: [{
	                  required: true,
	                  message: 'Missing value'
	                }]
	              },
	              children: [{
	                value: 'SET',
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.change.types.dropdown.option.set.label',
	                  defaultMessage: 'Set'
	                })
	              }, {
	                value: 'INCREASE',
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.change.types.dropdown.option.increase.label',
	                  defaultMessage: 'Increase'
	                })
	              }, {
	                value: 'DECREASE',
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.change.types.dropdown.option.decrease.label',
	                  defaultMessage: 'Decrease'
	                })
	              }]
	            }];
	
	            switch (currentActionValueFlagValue) {
	              case 'SET':
	                {
	                  fields.push({
	                    id: 'change_bid_budget_set',
	                    name: 'actionValue',
	                    format: 'currency',
	                    decorator: {
	                      rules: [{
	                        required: true,
	                        message: 'Missing value'
	                      }],
	                      type: 'number',
	                      initialValue: _this.state.form.actionValue
	                    },
	                    formItem: {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'task.change.set.label',
	                        defaultMessage: 'to'
	                      })
	                    }
	                  });
	                  break;
	                }
	              case 'INCREASE':
	                {
	                  fields.push({
	                    id: 'change_bid_budget_by',
	                    name: 'actionValue',
	                    format: 'integer',
	                    formItem: {
	                      label: 'by'
	                    },
	                    decorator: {
	                      rules: [{
	                        required: true,
	                        message: 'Missing value'
	                      }],
	                      type: 'number',
	                      initialValue: _this.state.form.actionValue ? parseFloat(_this.state.form.actionValue) : null
	                    },
	                    props: {
	                      min: 0
	                    },
	                    buddy: {
	                      id: 'change_bid_budget_by_unit',
	                      name: 'actionValueUnit',
	                      format: 'select',
	                      decorator: {
	                        rules: [{
	                          required: true,
	                          message: 'Missing value'
	                        }],
	                        initialValue: _this.state.form.actionValueUnit ? _this.state.form.actionValueUnit : 'DOLLAR'
	                      },
	                      children: [{
	                        label: '$',
	                        value: 'DOLLAR'
	                      }, {
	                        label: '%',
	                        value: 'PERCENT'
	                      }]
	                    }
	                  });
	                  fields.push({
	                    id: 'change_bid_budget_bound',
	                    name: 'actionValueBound',
	                    format: 'currency',
	                    formItem: {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'task.change.maximum.label',
	                        defaultMessage: 'to a maximum of'
	                      })
	                    },
	                    decorator: {
	                      rules: [{
	                        required: false
	                      }],
	                      type: 'number',
	                      initialValue: _this.state.form.actionValueBound ? parseFloat(_this.state.form.actionValueBound) : null
	                    }
	                  });
	                  break;
	                }
	              case 'DECREASE':
	                {
	                  fields.push({
	                    id: 'change_bid_budget_by',
	                    name: 'actionValue',
	                    format: 'integer',
	                    formItem: {
	                      label: 'by'
	                    },
	                    decorator: {
	                      rules: [{
	                        required: true,
	                        message: 'Missing value'
	                      }],
	                      type: 'number',
	                      initialValue: _this.state.form.actionValue ? parseFloat(_this.state.form.actionValue) : null
	                    },
	                    props: {
	                      min: 0
	                    },
	                    buddy: {
	                      id: 'change_bid_budget_by_unit',
	                      name: 'actionValueUnit',
	                      format: 'select',
	                      decorator: {
	                        rules: [{
	                          required: true,
	                          message: 'Missing value'
	                        }],
	                        initialValue: _this.state.form.actionValueUnit ? _this.state.form.actionValueUnit : 'DOLLAR'
	                      },
	                      children: [{
	                        label: '$',
	                        value: 'DOLLAR'
	                      }, {
	                        label: '%',
	                        value: 'PERCENT'
	                      }]
	                    }
	                  });
	                  fields.push({
	                    id: 'change_bid_budget_bound',
	                    name: 'actionValueBound',
	                    format: 'currency',
	                    formItem: {
	                      label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'task.change.minimum.label',
	                        defaultMessage: 'to a minimum of'
	                      })
	                    },
	                    decorator: {
	                      rules: [{
	                        required: false
	                      }],
	                      type: 'number',
	                      initialValue: _this.state.form.actionValueBound ? parseFloat(_this.state.form.actionValueBound) : null
	                    }
	                  });
	                  break;
	                }
	              default:
	                {
	                  break;
	                }
	            }
	            break;
	          }
	        case 'NOTIFY':
	          {
	            var parsedDefaultValue = void 0;
	            if (_this.state.form.actionValue && _this.state.form.actionValue !== '') {
	              if (_this.state.form.actionValue.indexOf(',') > -1) {
	                parsedDefaultValue = _this.state.form.actionValue.split(',');
	              } else {
	                parsedDefaultValue = [_this.state.form.actionValue];
	              }
	            } else {
	              parsedDefaultValue = [];
	            }
	            fields = [{
	              id: 'notify_email_addresses',
	              name: 'actionValue',
	              format: 'select',
	              props: {
	                mode: 'tags',
	                style: {
	                  width: 200
	                },
	                className: "select-tags-show-whitespace"
	              },
	              formItem: {
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'task.notify.emails.label',
	                  defaultMessage: 'Email addresses'
	                })
	              },
	              children: _this.props.users.data,
	              decorator: {
	                rules: [{
	                  required: true,
	                  message: 'Missing value'
	                }],
	                initialValue: parsedDefaultValue
	              }
	            }];
	            break;
	          }
	        default:
	          break;
	      }
	      return fields;
	    }, _this.isFormValid = function () {
	      if (typeof _this.state.isValid !== 'undefined') return _this.state.isValid;
	      return (0, _helpers.isTaskValid)(_this.state.form, _this.props.ruleSettings.aggregationLevel);
	    }, _this.onValidationInputsChange = function (values) {
	      if (values) {
	        var parsed = (0, _assign2.default)({}, values);
	        if (_this.state.form.action === 'CHANGE_STATE') {
	          if (parsed.actionValue) {
	            if (parsed.actionValue === 'PAUSED') {
	              parsed.actionValueFlag = null;
	            }
	          }
	          if (typeof values.actionValueFlag !== 'undefined') {
	            parsed.actionValueFlag = values.actionValueFlag === true ? 'MANUAL' : null;
	          }
	        } else if (_this.state.form.action === 'NOTIFY') {
	          if (values.actionValue && values.actionValue.length && values.actionValue.length > 0) {
	            parsed.actionValue = values.actionValue.join(',');
	          }
	        } else if (_this.state.form.action === 'CHANGE_BID' || _this.state.form.action === 'CHANGE_BUDGET') {
	          if (values.actionValueFlag && _this.state.form.actionValueFlag !== values.actionValueFlag) {
	            parsed.actionValue = null;
	            parsed.actionValueUnit = 'DOLLAR';
	            parsed.actionValueBound = null;
	          }
	        }
	
	        _this.setState({ form: (0, _immutabilityHelper2.default)(_this.state.form, {
	            $merge: parsed
	          }) });
	      }
	    }, _this.updateValidationInputsValidation = function (isValid, updateStore, fields) {
	      var _this$props2 = _this.props,
	          ruleBranchID = _this$props2.ruleBranchID,
	          task = _this$props2.task,
	          builderActions = _this$props2.builderActions;
	
	
	      _this.setState({ isValid: isValid }, function () {
	        if (updateStore === true) {
	          builderActions('updateEntitiesValidation', {
	            ruleBranches: ruleBranchID,
	            tasks: task.id
	          }, isValid);
	        }
	      });
	    }, _this.saveTask = function () {
	      var _this$props3 = _this.props,
	          task = _this$props3.task,
	          taskActions = _this$props3.taskActions,
	          ruleBranchID = _this$props3.ruleBranchID;
	
	      var form = (0, _assign2.default)({}, _this.state.form);
	      taskActions.cancelEdit(task.id);
	      taskActions.update(task.id, ruleBranchID, {
	        action: form.action,
	        actionValue: form.actionValue,
	        actionValueFlag: form.actionValueFlag,
	        actionValueBound: form.actionValueBound ? form.actionValueBound : null,
	        actionValueUnit: form.actionValueUnit
	      });
	    }, _this.cancelSaveTask = function () {
	      var _this$props4 = _this.props,
	          task = _this$props4.task,
	          ruleBranchID = _this$props4.ruleBranchID,
	          taskActions = _this$props4.taskActions,
	          ruleSettings = _this$props4.ruleSettings;
	      var id = task.id,
	          action = task.action,
	          actionValue = task.actionValue,
	          actionValueFlag = task.actionValueFlag,
	          actionValueBound = task.actionValueBound,
	          actionValueUnit = task.actionValueUnit;
	      // existing task
	
	      _this.updateValidationInputsValidation(true);
	      if ((0, _helpers.isTaskValid)(task, ruleSettings.aggregationLevel)) {
	        _this.setState({
	          form: {
	            action: action,
	            actionValue: actionValue,
	            actionValueFlag: actionValueFlag,
	            actionValueBound: actionValueBound,
	            actionValueUnit: actionValueUnit
	          }
	        }, function () {
	          taskActions.cancelEdit(id);
	        });
	      } else {
	        taskActions.remove(ruleBranchID, id);
	      }
	    }, _this.getFormKey = function () {
	      var formKey = _this.state.form.action ? _this.state.form.action : 'task-edit-form';
	      if ((_this.state.form.action === 'CHANGE_BID' || _this.state.form.action === 'CHANGE_BUDGET') && _this.state.form.actionValueFlag) {
	        formKey += '-' + _this.state.form.actionValueFlag;
	      }
	      return formKey;
	    }, _this.editView = function () {
	      var aggregationLevel = _this.props.ruleSettings.aggregationLevel;
	
	      var selectConfig = {
	        onChange: _this.actionChange,
	        style: {
	          width: 150
	        },
	        placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'task.action.select.placeholder',
	          defaultMessage: 'Select Action'
	        })
	      };
	      var editActions = _react2.default.createElement(
	        'div',
	        { className: 'text-align-right' },
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            onClick: function onClick() {
	              return _this.saveTask();
	            },
	            type: 'primary',
	            className: 'task-save-button',
	            disabled: !_this.isFormValid()
	          },
	          _react2.default.createElement(_antd.Icon, { type: 'check' })
	        ),
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            onClick: function onClick() {
	              return _this.cancelSaveTask();
	            },
	            type: 'default',
	            className: 'task-cancel-save-button'
	          },
	          _react2.default.createElement(_antd.Icon, { type: 'close' })
	        )
	      );
	      var selectMarkup = void 0;
	      var additionalFields = void 0;
	      var helperText = void 0;
	      var actionFeedback = void 0;
	
	      if (aggregationLevel) {
	        var _find = find(_constants.AGGREGATION_LEVELS, function (aggregation) {
	          return aggregation.value === aggregationLevel;
	        }),
	            availableActions = _find.availableActions;
	
	        var actionsOptions = availableActions.map(function (availableActionName) {
	          var _AVAILABLE_ACTIONS$fi = _constants.AVAILABLE_ACTIONS.find(function (action) {
	            return action.value === availableActionName;
	          }),
	              label = _AVAILABLE_ACTIONS$fi.label;
	
	          return _react2.default.createElement(
	            Option,
	            { value: availableActionName, key: availableActionName },
	            label
	          );
	        });
	
	        selectMarkup = _react2.default.createElement(
	          _antd.Select,
	          (0, _extends3.default)({}, selectConfig, { defaultValue: _this.props.task.action, style: { width: '100%' } }),
	          actionsOptions
	        );
	
	        actionFeedback = _this.state.form.action && !(0, _helpers.isActionValid)(_this.props.ruleSettings.aggregationLevel, _this.state.form.action) ? {
	          validateStatus: 'error',
	          help: _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'task.aggregationLevel.invalid.action',
	            defaultMessage: 'Invalid action for Rule scope.'
	          })
	        } : null;
	
	        if (!actionFeedback) {
	          var fields = _this.getFieldsForAction(_this.state.form.action);
	          additionalFields = _react2.default.createElement(_ValidationInputs2.default, {
	            'for': _this.state.form.action,
	            key: _this.getFormKey(),
	            fields: fields,
	            onChange: _this.onValidationInputsChange,
	            isValid: _this.updateValidationInputsValidation
	          });
	          helperText = _this.getConditionalHelperText(_this.state.form.action);
	        }
	      } else {
	        selectMarkup = _react2.default.createElement(
	          _antd.Tooltip,
	          {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'task.aggregationLevel.invalid.actions.dropdown.tooltip',
	              defaultMessage: 'Select campaigns to apply rule to first'
	            })
	          },
	          _react2.default.createElement(_antd.Select, (0, _extends3.default)({}, selectConfig, { disabled: true })),
	          null
	        );
	      }
	      var helperMarkup = helperText ? _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 24, className: 'helper-text' },
	          helperText
	        )
	      ) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-view' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 20 },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 24 },
	                _react2.default.createElement(
	                  _antd.Row,
	                  { type: 'flex', justify: 'start' },
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 4, className: 'm-r-16' },
	                    _react2.default.createElement(
	                      FormItem,
	                      actionFeedback,
	                      selectMarkup
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    null,
	                    additionalFields
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Row,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 24 },
	                    helperMarkup
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, className: 'text-align-right' },
	            editActions
	          )
	        )
	      );
	    }, _this.readOnlyView = function () {
	      var _this$props5 = _this.props,
	          task = _this$props5.task,
	          taskActions = _this$props5.taskActions,
	          ruleBranchID = _this$props5.ruleBranchID;
	
	
	      return _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 24, className: 'read-only-view' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20, className: 'show-white-space' },
	              (0, _selectors.taskDescriptionBuilder)({ task: _this.props.task })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 4, className: 'text-align-right' },
	              _react2.default.createElement(_antd.Button, {
	                icon: 'edit',
	                size: 'small',
	                key: 'task-edit-button',
	                className: 'task-edit-button',
	                onClick: function onClick() {
	                  taskActions.edit(task.id);
	                }
	              }),
	              _react2.default.createElement(_antd.Button, {
	                icon: 'close',
	                size: 'small',
	                key: 'task-remove-button',
	                className: 'task-remove-button',
	                onClick: function onClick() {
	                  taskActions.remove(ruleBranchID, task.id);
	                }
	              })
	            )
	          )
	        )
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Task, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          taskActions = _props.taskActions,
	          task = _props.task;
	      var id = task.id,
	          action = task.action,
	          actionValue = task.actionValue,
	          actionValueFlag = task.actionValueFlag,
	          actionValueBound = task.actionValueBound,
	          actionValueUnit = task.actionValueUnit;
	
	
	      this.setState({
	        form: {
	          action: action,
	          actionValue: actionValue,
	          actionValueFlag: actionValueFlag,
	          actionValueBound: actionValueBound,
	          actionValueUnit: actionValueUnit
	        }
	      }, function () {
	        // dispatch edit for this condition if the form is invalid
	        if (!_this2.isFormValid()) {
	          taskActions.edit(id);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          ruleSettings = _props2.ruleSettings,
	          editing = _props2.editing,
	          taskActions = _props2.taskActions,
	          task = _props2.task,
	          ruleBranchID = _props2.ruleBranchID;
	
	
	      if (ruleSettings.aggregationLevel && ruleSettings.aggregationLevel !== nextProps.ruleSettings.aggregationLevel) {
	        if (!(0, _helpers.isActionValid)(nextProps.ruleSettings.aggregationLevel, this.state.form.action)) {
	          if (!editing) taskActions.edit(task.id);
	          this.props.builderActions('updateEntitiesValidation', {
	            ruleBranches: ruleBranchID,
	            tasks: task.id
	          }, false);
	        }
	      }
	    }
	
	    /**
	     * Whenever an action changes, we want to reset
	     * the state form with the newly updated action,
	     * affectively removing all the previous action's
	     * fields information as well.
	     */
	
	
	    /**
	     * We check if the form is valid here.
	     * The condition is considered valid if there is a presence of
	     * fact, operator and (valueDecimal OR valueString OR valueJson (needs to not be empty)).
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var editing = this.props.editing;
	
	      var taskBody = void 0;
	      if (editing === true) {
	        taskBody = this.editView();
	      } else {
	        taskBody = this.readOnlyView();
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'task__component' },
	        taskBody
	      );
	    }
	  }]);
	  return Task;
	}(_react2.default.Component), _class.propTypes = {
	  ruleSettings: _propTypes2.default.shape({
	    aggregationLevel: _propTypes2.default.oneOf(['FB_CAMPAIGN', 'FB_ADSET', 'FB_AD'])
	  }).isRequired,
	  editing: _propTypes2.default.bool.isRequired,
	  ruleBranchID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  task: _propTypes2.default.shape({
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    action: _propTypes2.default.oneOf(['CHANGE_STATE', 'CHANGE_BID', 'CHANGE_BUDGET', 'NOTIFY'])
	  }).isRequired,
	  taskActions: _propTypes2.default.shape({
	    update: _propTypes2.default.func.isRequired,
	    remove: _propTypes2.default.func.isRequired,
	    edit: _propTypes2.default.func.isRequired,
	    cancelEdit: _propTypes2.default.func.isRequired
	  }).isRequired,
	  users: _propTypes2.default.shape({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      label: _propTypes2.default.string.isRequired,
	      value: _propTypes2.default.string.isRequired
	    })).isRequired,
	    loading: _propTypes2.default.bool.isRequired
	  }).isRequired,
	  builderActions: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = Task;

/***/ },

/***/ 3822:
/***/ function(module, exports) {



/***/ },

/***/ 3823:
/***/ function(module, exports) {



/***/ },

/***/ 3824:
/***/ function(module, exports) {



/***/ }

});


// WEBPACK FOOTER //
// 4.webpack_build.js